(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3721],{

/***/ 36964:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(6212);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41248);
/* harmony import */ var _PasswordValidation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54876);
/* harmony import */ var react_bootstrap_Spinner__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(36968);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _redux_Login_redux_selector__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54549);
/* harmony import */ var _redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30387);
/* harmony import */ var _UI_CustomToast__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48509);
/* harmony import */ var _CheckBox__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(88023);
/* harmony import */ var _Password__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(62330);
/* harmony import */ var _utils_logger__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(81923);













const PartnerSignup = (show)=>{
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    const [showPassword, setShowPassword] = react__WEBPACK_IMPORTED_MODULE_1__.useState(false);
    const [loading, setloading] = react__WEBPACK_IMPORTED_MODULE_1__.useState(false);
    const nameRegExp = /^([a-zA-Z]+\s?)*\s*$/;
    const urlRegex = /^[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=-]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*$)/;
    // const emailRegex= /^[a-zA-Z0-9.]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
    const emailRegex = /^[a-zA-Z0-9.]+@[a-z]+\.[a-z]{2,3}$/;
    const passwordRegex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]).{8,}$/;
    const form = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_redux_Login_redux_selector__WEBPACK_IMPORTED_MODULE_5__/* .selectPartnerForm */ .kc);
    const handlePartnerSignupChange = (evt)=>{
        const { name , value  } = evt.target;
        dispatch(_redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_6__/* .actions.updatePartnerFormValue */ .Nw.updatePartnerFormValue({
            key: name,
            value
        }));
        (0,_utils_logger__WEBPACK_IMPORTED_MODULE_10__/* .log */ .c)(form);
    };
    const handleCheckBoxChange = (evt)=>{
        (0,_utils_logger__WEBPACK_IMPORTED_MODULE_10__/* .log */ .c)(evt, "evt");
        dispatch(_redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_6__/* .actions.updatePartnerFormValue */ .Nw.updatePartnerFormValue({
            key: "tmc",
            value: evt.target.checked ? true : false
        }));
    };
    const [highlight, setHighlight] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const handleKeyDown = (e)=>{
        if (e.key === "Enter") {
            hendlePartnerSignUp();
            setHighlight("0.5px 0.5px 3px #fff, 2px 2px 10px #3165BA");
            setTimeout(()=>{
                setHighlight("");
            }, 1000);
        }
    };
    const userRole = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_redux_Login_redux_selector__WEBPACK_IMPORTED_MODULE_5__/* .selectUserRole */ .nC);
    const hendlePartnerSignUp = ()=>{
        var _form_firstName, _form_lastName, _form_email, _form_password, _form_businessName, _form_webUrl;
        dispatch(_redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_6__/* .actions.updatePartnerFormValue */ .Nw.updatePartnerFormValue({
            key: "firstName",
            value: form === null || form === void 0 ? void 0 : (_form_firstName = form.firstName) === null || _form_firstName === void 0 ? void 0 : _form_firstName.trim()
        }));
        dispatch(_redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_6__/* .actions.updatePartnerFormValue */ .Nw.updatePartnerFormValue({
            key: "lastName",
            value: form === null || form === void 0 ? void 0 : (_form_lastName = form.lastName) === null || _form_lastName === void 0 ? void 0 : _form_lastName.trim()
        }));
        dispatch(_redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_6__/* .actions.updatePartnerFormValue */ .Nw.updatePartnerFormValue({
            key: "email",
            value: form === null || form === void 0 ? void 0 : (_form_email = form.email) === null || _form_email === void 0 ? void 0 : _form_email.trim()
        }));
        dispatch(_redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_6__/* .actions.updatePartnerFormValue */ .Nw.updatePartnerFormValue({
            key: "password",
            value: form === null || form === void 0 ? void 0 : (_form_password = form.password) === null || _form_password === void 0 ? void 0 : _form_password.trim()
        }));
        dispatch(_redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_6__/* .actions.updatePartnerFormValue */ .Nw.updatePartnerFormValue({
            key: "businessName",
            value: form === null || form === void 0 ? void 0 : (_form_businessName = form.businessName) === null || _form_businessName === void 0 ? void 0 : _form_businessName.trim()
        }));
        dispatch(_redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_6__/* .actions.updatePartnerFormValue */ .Nw.updatePartnerFormValue({
            key: "webUrl",
            value: form === null || form === void 0 ? void 0 : (_form_webUrl = form.webUrl) === null || _form_webUrl === void 0 ? void 0 : _form_webUrl.trim()
        }));
        if (!nameRegExp.test(form.firstName) || form.firstName.trim() == "") {
            (0,_UI_CustomToast__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("Enter Valid first Name", "ERROR");
            return;
        }
        if (!nameRegExp.test(form.lastName) || form.lastName.trim() == "") {
            (0,_UI_CustomToast__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("Enter Valid Last Name", "ERROR");
            return;
        }
        if (!nameRegExp.test(form.businessName) || form.businessName.trim() == "") {
            (0,_UI_CustomToast__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("Enter Valid Business Name", "ERROR");
            return;
        }
        if (form.email.length === 0) {
            (0,_UI_CustomToast__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("Please Enter Email", "ERROR");
            return;
        }
        if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(form.email)) {
            (0,_UI_CustomToast__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("Enter Valid Email ID", "ERROR");
            return;
        }
        dispatch(_redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_6__/* .actions.doPartnerSignUp */ .Nw.doPartnerSignUp({
            role: userRole,
            callback: ()=>{
                dispatch(_redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_6__/* .actions.clearPartnerFrom */ .Nw.clearPartnerFrom());
                dispatch(_redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_6__/* .actions.BecomeAPartnerFormShowHide */ .Nw.BecomeAPartnerFormShowHide(false));
            }
        }));
    };
    const partnersignup = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_redux_Login_redux_selector__WEBPACK_IMPORTED_MODULE_5__/* .BecomeAPartnerForm */ .i);
    const handlepartnersignup = (data)=>{
        dispatch(_redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_6__/* .actions.clearPartnerFrom */ .Nw.clearPartnerFrom());
        dispatch(_redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_6__/* .actions.BecomeAPartnerFormShowHide */ .Nw.BecomeAPartnerFormShowHide(data));
    };
    const handleopenlogin = ()=>{
        dispatch(_redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_6__/* .actions.SignInFormShowHide */ .Nw.SignInFormShowHide(true));
        dispatch(_redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_6__/* .actions.BecomeAPartnerFormShowHide */ .Nw.BecomeAPartnerFormShowHide(false));
    };
    const handleClickShowPassword = ()=>{
        setShowPassword(!showPassword);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
            show: partnersignup,
            dialogClassName: "model-custom",
            "aria-labelledby": "example-custom-modal-styling-title",
            fullscreen: "sm-down",
            className: "modal-signup modal-close mt-md-3",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_11__/* ["default"].Header */ .Z.Header, {
                    closeButton: true,
                    onHide: ()=>handlepartnersignup(false),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_11__/* ["default"].Title */ .Z.Title, {
                        id: "example-custom-modal-styling-title",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                            className: "signup-header p-0 m-0 fw-semibold",
                            children: "Start Promoting Your Retreats Today !"
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_11__/* ["default"].Body */ .Z.Body, {
                    className: "py-1",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "pb-2",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "col-12 d-flex justify-content-between flex-row",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                        className: "signup-text paragraph fw-semibold",
                                                        children: "First Name"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                        type: "text",
                                                        placeholder: "First Name",
                                                        name: "firstName",
                                                        value: form.firstName,
                                                        onChange: handlePartnerSignupChange,
                                                        className: "py-2 px-2 w-100 rounded border signup-text fw-500 placeholder-password",
                                                        required: true
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "ps-3",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                        className: "signup-text paragraph fw-semibold",
                                                        children: "Last Name"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                        type: "text",
                                                        placeholder: "Last Name",
                                                        name: "lastName",
                                                        value: form.lastName,
                                                        onChange: handlePartnerSignupChange,
                                                        className: "py-2 px-2 rounded border signup-text fw-500 w-100 placeholder-password",
                                                        required: true
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "col-12 mt-2",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                className: "signup-text paragraph fw-semibold",
                                                children: "Business Name"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                type: "text",
                                                placeholder: "Enter Business Name",
                                                name: "businessName",
                                                value: form.businessName,
                                                onChange: handlePartnerSignupChange,
                                                maxLength: 60,
                                                className: "col-12 py-2 px-2 rounded border signup-text fw-500 placeholder-password",
                                                required: true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "col-12 mt-2",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                className: "signup-text paragraph fw-semibold",
                                                children: "Website URL"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                type: "text",
                                                placeholder: "Enter Website URL",
                                                name: "webUrl",
                                                value: form.webUrl,
                                                onChange: handlePartnerSignupChange,
                                                className: "col-12 py-2 px-2 rounded border signup-text fw-500 placeholder-password ",
                                                required: true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "col-12 mt-2",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                className: "signup-text paragraph fw-semibold",
                                                children: "Email Address"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                type: "text",
                                                placeholder: "Enter Email Address",
                                                name: "email",
                                                value: form.email,
                                                onChange: handlePartnerSignupChange,
                                                className: "col-12 py-2 px-2 rounded border signup-text fw-500 placeholder-password",
                                                required: true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "mt-2",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                className: "signup-text paragraph fw-semibold",
                                                children: "Password"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Password__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                value: form.password,
                                                name: "password",
                                                className: "signup-text paragraph fw-500",
                                                handleFieldChange: handlePartnerSignupChange,
                                                placeholder: "Enter Password",
                                                showPassword: showPassword,
                                                handleClickShowPassword: handleClickShowPassword,
                                                handleKeyDown: handleKeyDown
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PasswordValidation__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                password: form.password
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "d-flex flex-row align-items-start my-3",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CheckBox__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                label: "",
                                                name: "tmc",
                                                forChecked: form.tmc,
                                                handleFieldChange: (e)=>handleCheckBoxChange(e),
                                                className: undefined
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                className: "form-check-label fs-10 pointer fw-500 ",
                                                htmlFor: "flexCheckDefault",
                                                style: {
                                                    marginLeft: "-15px"
                                                },
                                                children: [
                                                    "I’ve Read and Understood the",
                                                    " ",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                        href: "/terms-and-conditions",
                                                        target: "_blank",
                                                        rel: "noreferrer",
                                                        className: "text-primary pointer",
                                                        children: [
                                                            " ",
                                                            "Terms of Service",
                                                            " "
                                                        ]
                                                    }),
                                                    " ",
                                                    "and I Offer Accommodation and Yoga Retreats in a Package."
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        className: "btn btnHover btn-sm w-100 bg-dark-blue py-2 fw-semibold text-white fs-14",
                                        type: "button",
                                        style: {
                                            width: "100px",
                                            boxShadow: highlight
                                        },
                                        onClick: hendlePartnerSignUp,
                                        children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Spinner__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                            animation: "border",
                                            style: {
                                                color: "white",
                                                width: "15px",
                                                height: "15px"
                                            }
                                        }) : "Register Now"
                                    })
                                ]
                            }),
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                className: "border byr-hover-black-theme-button border-2 rounded bg-white p-2 w-100 paragraph d-flex align-items-center justify-content-start my-2",
                                onClick: handleopenlogin,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "m-0 w-100 fw-semibold text-center signup-text",
                                    style: {
                                        color: "#5e5e5e !important"
                                    },
                                    children: "Partner Sign In"
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PartnerSignup);


/***/ }),

/***/ 54876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _common_form_inputs_FormErrorMessage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16540);
// import FormErrorMessage from "components/common/form-inputs/FormErrorMessage"


const passwordRegex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]).{8,}$/;
const PasswordValidation = (param)=>{
    let { password  } = param;
    let count = /^.{8,}/.test(password) ? "" : "minimum 8 characters,";
    let upperCase = /^(?=.*?[A-Z])/.test(password) ? "" : "at least one uppercase letter,";
    let lowerCase = /^(?=.*?[a-z])/.test(password) ? "" : "one lowercase letter,";
    let numberCount = /^(?=.*?[0-9])/.test(password) ? "" : "one number,";
    let specialChar = /^(?=.*?[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])/.test(password) ? "" : "and one special character";
    let errorMessage = "Password must contain ".concat(count, " ").concat(upperCase, " ").concat(lowerCase, " ").concat(numberCount, " ").concat(specialChar);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: password !== "" && !passwordRegex.test(password) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_form_inputs_FormErrorMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            error: errorMessage.replace(/,\s*$/, ""),
            errorStyles: {
                fontSize: "10px"
            }
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PasswordValidation);


/***/ }),

/***/ 95094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41248);
/* harmony import */ var react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(6212);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(12529);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(31451);
/* harmony import */ var _Firebase_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76855);
/* harmony import */ var _redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30387);
/* harmony import */ var _UI_CustomToast__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48509);
/* harmony import */ var react_cookie__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(70461);
/* harmony import */ var _redux_Frontend_WishList_redux_slice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(32123);
/* harmony import */ var _redux_Login_redux_selector__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(54549);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _CheckBox__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(88023);
/* harmony import */ var _Password__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(62330);
/* harmony import */ var _PasswordValidation__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(54876);
/* harmony import */ var _environment__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(58034);
/* harmony import */ var _utils_logger__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(81923);


// redux
















const SignIn = (param)=>{
    let { handleShowSignup , handleShowForgotPassword , handleShowPartnerSignup  } = param;
    const [showPassword, setShowPassword] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [fooundGoogleAccountError, setFooundGoogleAccountError] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_8__.useRouter)();
    const form = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_redux_Login_redux_selector__WEBPACK_IMPORTED_MODULE_7__/* .selectLoginForm */ .Fg);
    const role = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_redux_Login_redux_selector__WEBPACK_IMPORTED_MODULE_7__/* .selectUserRole */ .nC);
    const [cookie, setCookie] = (0,react_cookie__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)([
        "token"
    ]);
    let unsubscribeFromAuth;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        unsubscribeFromAuth = _Firebase_utils__WEBPACK_IMPORTED_MODULE_3__/* .auth.onAuthStateChanged */ .I8.onAuthStateChanged((user)=>{
            if (user) {
                (0,_utils_logger__WEBPACK_IMPORTED_MODULE_13__/* .log */ .c)("user datae", user.providerData);
                responseGoogle(user.providerData);
            }
        });
        return ()=>{
            unsubscribeFromAuth();
            _Firebase_utils__WEBPACK_IMPORTED_MODULE_3__/* .auth.signOut */ .I8.signOut();
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{}, [
        role
    ]);
    let token = "";
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        token = localStorage.getItem("token");
        return ()=>{};
    }, []);
    const responseGoogle = (response)=>{
        (0,_utils_logger__WEBPACK_IMPORTED_MODULE_13__/* .log */ .c)(response, "GoogleResponce");
        let googleData = {
            name: response[0].displayName,
            email: response[0].email,
            phoneNo: response[0].phoneNumber,
            profilePic: response[0].photoURL,
            socialId: response[0].uid
        };
        dispatch(_redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_4__/* .actions.googleLogin */ .Nw.googleLogin({
            data: googleData,
            callback: (datatoken)=>{
                _Firebase_utils__WEBPACK_IMPORTED_MODULE_3__/* .auth.signOut */ .I8.signOut();
                (0,_utils_logger__WEBPACK_IMPORTED_MODULE_13__/* .log */ .c)(datatoken, "dataLogin");
                setCookie("token", datatoken, {
                    path: "/",
                    domain: _environment__WEBPACK_IMPORTED_MODULE_12__/* .COOKIE_DOMAIN */ .JP,
                    secure: true,
                    maxAge: 3600000000,
                    sameSite: "none"
                });
                setTimeout(()=>{
                    dispatch(_redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_4__/* .actions.getUserProfile */ .Nw.getUserProfile({
                        token: datatoken,
                        callback: (data)=>{
                            if (data.role == 2) {
                                dispatch(_redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_4__/* .actions.SignInFormShowHide */ .Nw.SignInFormShowHide(false));
                                router.push("/school/dashboard");
                                dispatch(_redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_4__/* .actions.clearFrom */ .Nw.clearFrom());
                            } else if (data.role == 3) {
                                dispatch(_redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_4__/* .actions.SignInFormShowHide */ .Nw.SignInFormShowHide(false));
                                dispatch(_redux_Frontend_WishList_redux_slice__WEBPACK_IMPORTED_MODULE_6__/* .actions.doGetWishlist */ .Nw.doGetWishlist());
                                // router.push("/");
                                window.location.href = "/";
                                dispatch(_redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_4__/* .actions.clearFrom */ .Nw.clearFrom());
                            } else {
                                dispatch(_redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_4__/* .actions.clearFrom */ .Nw.clearFrom());
                                // router.push("/");
                                window.location.href = "/";
                                dispatch(_redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_4__/* .actions.SignInFormShowHide */ .Nw.SignInFormShowHide(false));
                            }
                        }
                    }));
                }, 1000);
            }
        }));
    };
    const dologinWithGoogle = ()=>{
        unsubscribeFromAuth = _Firebase_utils__WEBPACK_IMPORTED_MODULE_3__/* .auth.onAuthStateChanged */ .I8.onAuthStateChanged((user)=>{
            if (user) {
                (0,_utils_logger__WEBPACK_IMPORTED_MODULE_13__/* .log */ .c)("user datae", user.providerData);
                responseGoogle(user.providerData);
            }
        });
        return ()=>{
            unsubscribeFromAuth();
            _Firebase_utils__WEBPACK_IMPORTED_MODULE_3__/* .auth.signOut */ .I8.signOut();
        };
    };
    const fetchMe = ()=>{
        dispatch(_redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_4__/* .actions.getUserProfile */ .Nw.getUserProfile({
            token: token,
            callback: (data)=>{
                if (data.role == 1) {} else {
                // router.push("/");
                }
            }
        }));
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        fetchMe();
        return ()=>{};
    }, []);
    const handleLoginChange = (evt)=>{
        const { name , value  } = evt.target;
        dispatch(_redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_4__/* .actions.updateLoginFormValue */ .Nw.updateLoginFormValue({
            key: name,
            value
        }));
    };
    const handleCheckBoxChange = (evt)=>{
        (0,_utils_logger__WEBPACK_IMPORTED_MODULE_13__/* .log */ .c)(evt, "evt");
        dispatch(_redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_4__/* .actions.updateLoginFormValue */ .Nw.updateLoginFormValue({
            key: "keeplogin",
            value: evt.target.checked ? true : false
        }));
    };
    const [highlight, setHighlight] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const handleKeyDown = (e)=>{
        if (e.key === "Enter") {
            hendleLogin();
            setHighlight("0.5px 0.5px 3px #fff, 2px 2px 10px #3165BA");
            setTimeout(()=>{
                setHighlight("");
            }, 1000);
        }
    };
    const hendleLogin = ()=>{
        var _form_email, _form_password;
        dispatch(_redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_4__/* .actions.updateLoginFormValue */ .Nw.updateLoginFormValue({
            key: "email",
            value: form === null || form === void 0 ? void 0 : (_form_email = form.email) === null || _form_email === void 0 ? void 0 : _form_email.trim()
        }));
        dispatch(_redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_4__/* .actions.updateLoginFormValue */ .Nw.updateLoginFormValue({
            key: "password",
            value: form === null || form === void 0 ? void 0 : (_form_password = form.password) === null || _form_password === void 0 ? void 0 : _form_password.trim()
        }));
        if (form.email.length === 0) {
            (0,_UI_CustomToast__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("Please Enter Email", "ERROR");
            return;
        }
        if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(form.email)) {
            (0,_UI_CustomToast__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("Enter Valid Email ID", "ERROR");
            return;
        }
        dispatch(_redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_4__/* .actions.doLogin */ .Nw.doLogin({
            callback: (datatoken)=>{
                (0,_utils_logger__WEBPACK_IMPORTED_MODULE_13__/* .log */ .c)(datatoken, "dataLogin");
                setCookie("token", datatoken, {
                    path: "/",
                    domain: _environment__WEBPACK_IMPORTED_MODULE_12__/* .COOKIE_DOMAIN */ .JP,
                    secure: true,
                    maxAge: 3600000000,
                    sameSite: "none"
                });
                dispatch(_redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_4__/* .actions.getUserProfile */ .Nw.getUserProfile({
                    token: datatoken,
                    callback: (data)=>{
                        if (data.role == 2) {
                            dispatch(_redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_4__/* .actions.SignInFormShowHide */ .Nw.SignInFormShowHide(false));
                            router.push("/school/dashboard");
                            (0,_UI_CustomToast__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("Partner Login Successfully", "SUCCESS");
                            dispatch(_redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_4__/* .actions.clearFrom */ .Nw.clearFrom());
                        } else if (data.role == 3) {
                            dispatch(_redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_4__/* .actions.SignInFormShowHide */ .Nw.SignInFormShowHide(false));
                            dispatch(_redux_Frontend_WishList_redux_slice__WEBPACK_IMPORTED_MODULE_6__/* .actions.doGetWishlist */ .Nw.doGetWishlist());
                            // router.push("/");
                            window.location.href = "/";
                            (0,_UI_CustomToast__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("User Login Successfully", "SUCCESS");
                            dispatch(_redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_4__/* .actions.clearFrom */ .Nw.clearFrom());
                        } else {
                            dispatch(_redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_4__/* .actions.clearFrom */ .Nw.clearFrom());
                            // router.push("/");
                            window.location.href = "/";
                            dispatch(_redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_4__/* .actions.SignInFormShowHide */ .Nw.SignInFormShowHide(false));
                        }
                    }
                }));
            }
        }));
    };
    const signinform = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_redux_Login_redux_selector__WEBPACK_IMPORTED_MODULE_7__/* .SignInFormForm */ .Zu);
    const handlesignupForm = (data)=>{
        dispatch(_redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_4__/* .actions.clearFrom */ .Nw.clearFrom());
        dispatch(_redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_4__/* .actions.SignInFormShowHide */ .Nw.SignInFormShowHide(data));
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        addEventListener("keydown", function(event) {
            if (event.key === "Enter") {
                if ((form === null || form === void 0 ? void 0 : form.email.length) != 0 && (form === null || form === void 0 ? void 0 : form.password.length) != 0) {
                    var _form_email, _form_password;
                    dispatch(_redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_4__/* .actions.updateLoginFormValue */ .Nw.updateLoginFormValue({
                        key: "email",
                        value: form === null || form === void 0 ? void 0 : (_form_email = form.email) === null || _form_email === void 0 ? void 0 : _form_email.trim()
                    }));
                    dispatch(_redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_4__/* .actions.updateLoginFormValue */ .Nw.updateLoginFormValue({
                        key: "password",
                        value: form === null || form === void 0 ? void 0 : (_form_password = form.password) === null || _form_password === void 0 ? void 0 : _form_password.trim()
                    }));
                    if (form.email.length === 0) {
                        (0,_UI_CustomToast__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("Please Enter Email", "ERROR");
                        return;
                    }
                    if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(form.email)) {
                        (0,_UI_CustomToast__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("Enter Valid Email ID", "ERROR");
                        return;
                    }
                    dispatch(_redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_4__/* .actions.doLogin */ .Nw.doLogin({
                        callback: (data)=>{
                            (0,_utils_logger__WEBPACK_IMPORTED_MODULE_13__/* .log */ .c)(data, "dataLogin");
                            setCookie("token", data, {
                                path: "/",
                                domain: _environment__WEBPACK_IMPORTED_MODULE_12__/* .COOKIE_DOMAIN */ .JP,
                                secure: true,
                                maxAge: 3600000000,
                                sameSite: "none"
                            });
                            dispatch(_redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_4__/* .actions.getUserProfile */ .Nw.getUserProfile({
                                token: token,
                                callback: (data)=>{
                                    if (data.role == 2) {
                                        dispatch(_redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_4__/* .actions.SignInFormShowHide */ .Nw.SignInFormShowHide(false));
                                        router.push("/school/dashboard");
                                        (0,_UI_CustomToast__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("Partner Login Successfully", "SUCCESS");
                                        dispatch(_redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_4__/* .actions.clearFrom */ .Nw.clearFrom());
                                    } else if (data.role == 3) {
                                        dispatch(_redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_4__/* .actions.SignInFormShowHide */ .Nw.SignInFormShowHide(false));
                                        dispatch(_redux_Frontend_WishList_redux_slice__WEBPACK_IMPORTED_MODULE_6__/* .actions.doGetWishlist */ .Nw.doGetWishlist());
                                        // router.push("/");
                                        window.location.href = "/";
                                        (0,_UI_CustomToast__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("User Login Successfully", "SUCCESS");
                                        dispatch(_redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_4__/* .actions.clearFrom */ .Nw.clearFrom());
                                    } else {
                                        dispatch(_redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_4__/* .actions.clearFrom */ .Nw.clearFrom());
                                        // router.push("/");
                                        window.location.href = "/";
                                        dispatch(_redux_Login_redux_slice__WEBPACK_IMPORTED_MODULE_4__/* .actions.SignInFormShowHide */ .Nw.SignInFormShowHide(false));
                                    }
                                }
                            }));
                        }
                    }));
                }
            }
        });
    }, [
        addEventListener
    ]);
    const handleClickShowPassword = ()=>{
        setShowPassword(!showPassword);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
            show: signinform,
            dialogClassName: "model-custom",
            "aria-labelledby": "example-custom-modal-styling-title",
            fullscreen: "sm-down",
            className: "modal-signup modal-close mt-md-5",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_15__/* ["default"].Header */ .Z.Header, {
                    closeButton: true,
                    onHide: ()=>handlesignupForm(false),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_15__/* ["default"].Title */ .Z.Title, {
                        id: "example-custom-modal-styling-title",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                            className: "signup-header p-0 m-0 fw-bold",
                            children: "Log In"
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_15__/* ["default"].Body */ .Z.Body, {
                    className: "py-1",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "",
                        children: [
                            fooundGoogleAccountError && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "col-12 mt-2 mb-lg-0 mb-3 mb-md-0 p-2",
                                style: {
                                    backgroundColor: "#f9d7cf",
                                    borderRadius: "5px"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "fs-11 m-0 p-0",
                                    children: fooundGoogleAccountError
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "col-12 mt-2 mb-lg-0 mb-3 mb-md-0",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                className: "signup-text paragraph fw-semibold",
                                                children: "Email Address"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                type: "email",
                                                placeholder: "Enter Email Address ",
                                                name: "email",
                                                value: form.email,
                                                onChange: handleLoginChange,
                                                className: "col-12 py-2 px-2 rounded border signup-text fw-500 ",
                                                required: true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "mt-2 mb-lg-0 mb-3 mb-md-0",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                className: "signup-text paragraph fw-semibold",
                                                children: "Password"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Password__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                value: form.password,
                                                name: "password",
                                                className: "signup-text paragraph fw-500",
                                                handleFieldChange: handleLoginChange,
                                                placeholder: "Enter Password",
                                                showPassword: showPassword,
                                                handleClickShowPassword: handleClickShowPassword,
                                                handleKeyDown: handleKeyDown
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PasswordValidation__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                password: form.password
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "d-flex flex-row align-items-center justify-content-between my-1 col-12 mb-lg-0 mb-3 mb-md-0",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "d-flex flex-row align-items-center ",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CheckBox__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                    label: "Keep me logged in",
                                                    name: "keeplogin",
                                                    forChecked: form.keeplogin,
                                                    handleFieldChange: (e)=>handleCheckBoxChange(e),
                                                    className: "form-check-label signup-text pointer fw-semibold"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "align ms-2 p-0 m-0 my-2",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_17__/* ["default"].Link */ .Z.Link, {
                                                    href: "#",
                                                    className: "m-0 p-0",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "m-0 signup-text text-dark-blue fw-semibold text-decoration-underline",
                                                        onClick: ()=>handleShowForgotPassword("user"),
                                                        children: "Forgot Password?"
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        className: "btn btnHover btn-sm w-100 bg-dark-blue text-white fw-semibold py-2 signup-text mb-lg-0 mb-3 mb-md-0",
                                        type: "button",
                                        onClick: hendleLogin,
                                        style: {
                                            boxShadow: highlight
                                        },
                                        children: "Log in"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "d-flex flex-row my-2 ",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                                        className: "col-5"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "pe-2 col-2 ps-3 fw-semibold signup-text pt-2",
                                        children: "OR"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                                        className: "col-5"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "col-12 pb-2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "border border-2 rounded bg-white pointer p-2 w-100 paragraph d-flex align-items-center justify-content-start my-2",
                                        onClick: ()=>{
                                            (0,_Firebase_utils__WEBPACK_IMPORTED_MODULE_3__/* .signInWithGoogle */ .qj)().catch((error)=>{});
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: "/images/icons8-google.svg",
                                                className: "img-fluid h-24",
                                                style: {
                                                    height: "24px!important"
                                                },
                                                height: "24px",
                                                width: "24px"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "m-0 w-100 fw-semibold text-center signup-text paragraph",
                                                children: "Continue with Google"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "col-12 d-flex align-items-center justify-content-center my-md-2 my-3",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                            className: "m-0 signup-text fw-semibold d-flex flex-row align-items-center pl-1 text-center mb-md-0",
                                            children: [
                                                "Dont have an account?",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_17__/* ["default"].Link */ .Z.Link, {
                                                    href: "#",
                                                    className: "p-0 m-0 ps-1 signup-text ",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "text-dark-blue m-0 p-0 fw-bold ",
                                                        onClick: handleShowSignup,
                                                        children: "Sign Up"
                                                    })
                                                }),
                                                " "
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        className: "border byr-hover-black-theme-button border-2 rounded bg-white p-2 w-100 paragraph d-flex align-items-center justify-content-start my-2",
                                        onClick: handleShowPartnerSignup,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "m-0 w-100 fw-semibold text-center signup-text",
                                            style: {
                                                color: "#5e5e5e !important"
                                            },
                                            children: "Partner Sign Up"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SignIn);


/***/ }),

/***/ 88023:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CheckboxLabels; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33366);
/* harmony import */ var _mui_material_FormGroup__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53457);
/* harmony import */ var _mui_material_FormControlLabel__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50480);
/* harmony import */ var _mui_material_Checkbox__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69368);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15861);







function CheckboxLabels(props) {
    const style = (0,_style__WEBPACK_IMPORTED_MODULE_2__/* .useStyles */ .y)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_FormGroup__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: " ".concat(style.MuiCheckbox, " paragraph align-items-center "),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_FormControlLabel__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            control: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Checkbox__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}),
            className: " ".concat(style.MuiCheckbox, " paragraph align-items-start "),
            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                className: props.className,
                children: props.label
            }),
            name: props.name,
            checked: props.forChecked,
            onChange: (e)=>props.handleFieldChange(e)
        })
    });
}


/***/ }),

/***/ 33366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ useStyles; }
/* harmony export */ });
/* harmony import */ var _mui_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19525);

const useStyles = (0,_mui_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    MuiCheckbox: {
        "& .MuiCheckbox-root": {
            paddingTop: "0",
            paddingBottom: "0",
            paddingRight: "5px",
            paddingLeft: "0"
        },
        "& .MuiFormControlLabel-labelPlacementEnd": {
            marginLeft: "0px ",
            alignItems: "center !important"
        },
        "& .css-7qmq4z.Mui-checked": {
            color: "#3165BA!important"
        },
        "& .css-j2otgh-MuiButtonBase-root-MuiCheckbox-root.Mui-checked": {
            color: "#3165BA!important"
        },
        "& .css-i4bv87-MuiSvgIcon-root": {
            width: "18px"
        },
        "& .css-vubbuv": {
            fontSize: "18px !important"
        }
    }
});


/***/ }),

/***/ 76855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I8": function() { return /* binding */ auth; },
/* harmony export */   "qj": function() { return /* binding */ signInWithGoogle; }
/* harmony export */ });
/* harmony import */ var firebase_app__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83977);
/* harmony import */ var firebase_auth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91259);


const firebaseConfig = {
    apiKey: "AIzaSyCjnY9XAXuPzpbLGUvKcFb42XqtRh14-aU",
    authDomain: "yogaretreats-44d91.firebaseapp.com",
    projectId: "yogaretreats-44d91",
    storageBucket: "yogaretreats-44d91.appspot.com",
    messagingSenderId: "636248726039",
    appId: "1:636248726039:web:3feddc7ef37c0ed22a1a52",
    measurementId: "G-5M06356TYV"
};
const app = (0,firebase_app__WEBPACK_IMPORTED_MODULE_0__/* .initializeApp */ .ZF)(firebaseConfig);
const auth = (0,firebase_auth__WEBPACK_IMPORTED_MODULE_1__/* .getAuth */ .v0)();
const provider = new firebase_auth__WEBPACK_IMPORTED_MODULE_1__/* .GoogleAuthProvider */ .hJ();
provider.setCustomParameters({
    prompt: "select_account"
});
const signInWithGoogle = ()=>(0,firebase_auth__WEBPACK_IMPORTED_MODULE_1__/* .signInWithPopup */ .rh)(auth, provider);
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (app)));


/***/ }),

/***/ 62330:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ InputAdornments; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@mui/material/OutlinedInput/OutlinedInput.js + 1 modules
var OutlinedInput = __webpack_require__(57709);
// EXTERNAL MODULE: ./node_modules/@mui/material/InputAdornment/InputAdornment.js + 1 modules
var InputAdornment = __webpack_require__(87109);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControl/FormControl.js + 1 modules
var FormControl = __webpack_require__(94054);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Visibility.js
var Visibility = __webpack_require__(22961);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/VisibilityOff.js
var VisibilityOff = __webpack_require__(72450);
// EXTERNAL MODULE: ./node_modules/@mui/styles/makeStyles/makeStyles.js + 30 modules
var makeStyles = __webpack_require__(19525);
;// CONCATENATED MODULE: ./components/Password/style.ts

const useStyles = (0,makeStyles/* default */.Z)({
    passwordField: {
        "& .MuiOutlinedInput-input": {
            padding: "6.5px 7px !important"
        },
        "& .MuiOutlinedInput-root": {
            paddingRight: "0",
            fontWeight: "500",
            borderRadius: "0.375rem !important",
            outline: "0px !important",
            maxHeight: "20px !important",
            padding: "6.5px 7px !important"
        },
        "& .css-1uvydh2": {
            padding: "6.8px 7px !important"
        },
        "& .css-2sv9kz": {
            paddingRight: "0"
        }
    }
});

;// CONCATENATED MODULE: ./components/Password/index.tsx









function InputAdornments(props) {
    const [showPassword, setShowPassword] = react.useState(false);
    const handleClickShowPassword = ()=>setShowPassword((show)=>!show);
    const style = useStyles();
    const handleMouseDownPassword = (event)=>{
        event.preventDefault();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
        className: "".concat(props.className),
        sx: {
            width: "100%"
        },
        variant: "outlined",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OutlinedInput/* default */.Z, {
            id: "outlined-adornment-password",
            type: props.showPassword ? "text" : "password",
            onChange: props.handleFieldChange,
            placeholder: props.placeholder,
            name: props.name,
            className: "".concat(style.passwordField, " ").concat(props.className),
            value: props.value,
            onKeyDown: props.handleKeyDown,
            sx: {
                "&:hover fieldset": {
                    border: "2px solid #3165ba !important"
                }
            },
            endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                position: "end",
                className: style.passwordField,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                    "aria-label": "toggle password visibility",
                    onClick: props.handleClickShowPassword,
                    children: props.showPassword ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Visibility/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilityOff/* default */.Z, {})
                })
            })
        })
    });
}


/***/ }),

/***/ 16540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67814);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59417);




const FormErrorMessage = (param)=>{
    let { error , errorStyles , showIcon =true  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "align-items-center d-flex mt-1",
        style: {
            ...errorStyles,
            fontSize: (errorStyles === null || errorStyles === void 0 ? void 0 : errorStyles.fontSize) || "10px",
            color: (errorStyles === null || errorStyles === void 0 ? void 0 : errorStyles.color) || "#c13515",
            lineHeight: (errorStyles === null || errorStyles === void 0 ? void 0 : errorStyles.lineHeight) || "16px"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .G, {
                icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_3__/* .faInfoCircle */ .sqG,
                className: "me-2 my-0 py-0",
                style: {
                    width: (errorStyles === null || errorStyles === void 0 ? void 0 : errorStyles.fontSize) || "10px"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "m-0 p-0 fw-500",
                children: error
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FormErrorMessage);


/***/ }),

/***/ 43721:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ MainLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(41248);
// EXTERNAL MODULE: ./utils/Api.tsx
var Api = __webpack_require__(93391);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-regular-svg-icons/index.mjs
var free_regular_svg_icons = __webpack_require__(34288);
// EXTERNAL MODULE: ./redux/Admin/SettingSection/WelcomeBar/redux/selector.tsx
var selector = __webpack_require__(44279);
// EXTERNAL MODULE: ./redux/Admin/SettingSection/WelcomeBar/redux/slice.tsx
var slice = __webpack_require__(17516);
// EXTERNAL MODULE: ./redux/Admin/SettingSection/WelcomeBar/types.tsx
var types = __webpack_require__(23840);
;// CONCATENATED MODULE: ./components/layout/main-layout/MainBanner.tsx







const MainBanner = (param)=>{
    let { closeBanner  } = param;
    const dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(()=>{
        dispatch(slice/* actions.setPageNo */.Nw.setPageNo(1));
        dispatch(slice/* actions.doGetWellcomeBarList */.Nw.doGetWellcomeBarList());
        return ()=>{};
    }, []);
    const WelcomeBar = (0,es/* useSelector */.v9)(selector/* selectWelcomeBarForm */.ug);
    const [TextFontSize, setTextFontSize] = (0,react.useState)(30);
    (0,react.useEffect)(()=>{
        setTextFontSize(WelcomeBar === null || WelcomeBar === void 0 ? void 0 : WelcomeBar.fontSize);
    }, [
        WelcomeBar === null || WelcomeBar === void 0 ? void 0 : WelcomeBar.fontSize
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: (WelcomeBar === null || WelcomeBar === void 0 ? void 0 : WelcomeBar.barStatus) == types/* StatusEnum.ACTIVE */.s.ACTIVE && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "banner byr-welcome-page-msg",
            style: {
                backgroundColor: (WelcomeBar === null || WelcomeBar === void 0 ? void 0 : WelcomeBar.backgroundColor) || "#3165BA",
                height: "".concat(WelcomeBar === null || WelcomeBar === void 0 ? void 0 : WelcomeBar.barHeight, "px") || 0,
                fontSize: "".concat(WelcomeBar === null || WelcomeBar === void 0 ? void 0 : WelcomeBar.fontSize, "px") || 0,
                // position: `${WelcomeBar?.barPosition == 2 ? "relative" : "fixed"}`,
                display: "flex",
                justifyContent: "center",
                color: (WelcomeBar === null || WelcomeBar === void 0 ? void 0 : WelcomeBar.textColor) || "#fff"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "banner__content pointer d-flex justify-content-between align-items-center",
                style: {
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "banner__text col-12 text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: WelcomeBar === null || WelcomeBar === void 0 ? void 0 : WelcomeBar.linkTo,
                            style: {
                                fontSize: "{".concat(TextFontSize, "px}"),
                                color: (WelcomeBar === null || WelcomeBar === void 0 ? void 0 : WelcomeBar.textColor) || "#fff"
                            },
                            children: WelcomeBar === null || WelcomeBar === void 0 ? void 0 : WelcomeBar.barMessage
                        })
                    }),
                    (WelcomeBar === null || WelcomeBar === void 0 ? void 0 : WelcomeBar.barPosition) == types/* BarPositionEnum.TOPFixed_WITH_DISMISS_ICON */.H.TOPFixed_WITH_DISMISS_ICON && /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                        className: "banner__close text-white fw-500",
                        onClick: closeBanner,
                        style: {
                            marginLeft: "-25px"
                        },
                        children: "x"
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var main_layout_MainBanner = (MainBanner);

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Modal.js + 6 modules
var Modal = __webpack_require__(6212);
// EXTERNAL MODULE: ./components/Auth/SignIn.tsx
var SignIn = __webpack_require__(95094);
// EXTERNAL MODULE: ./components/Auth/PartnerSignup.tsx
var PartnerSignup = __webpack_require__(36964);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Form.js + 12 modules
var Form = __webpack_require__(12529);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Nav.js + 2 modules
var Nav = __webpack_require__(31451);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Spinner.js
var Spinner = __webpack_require__(36968);
;// CONCATENATED MODULE: ./components/Auth/PartnerSignIn.tsx







const PartnerSignIn = (param)=>{
    let { show , handleShowPartnerSignup , handleShowPartnerSignin , handleShowForgotPassword , handleShowSignin  } = param;
    const dispatch = (0,es/* useDispatch */.I0)();
    const [showPassword, setShowPassword] = (0,react.useState)(false);
    const [partnerSigninEmail, setPartnerSigninEmail] = (0,react.useState)("");
    const [partnerSigninPassword, setPartnerSigninPassword] = (0,react.useState)("");
    const [isLoading, setisLoading] = (0,react.useState)(false);
    const loading = ()=>{
        setisLoading(!isLoading);
    };
    const handlePartnerSigninSubmit = (e)=>{};
    const handlePartnerSigninChange = (e)=>{
        if (e.target.name === "partnerSigninEmail") {
            setPartnerSigninEmail(e.target.value);
        } else if (e.target.name === "partnerSigninPassword") {
            setPartnerSigninPassword(e.target.value);
        }
    };
    const resetPartnerSigninForm = ()=>{
        handleShowPartnerSignin();
        setPartnerSigninEmail("");
        setPartnerSigninPassword("");
    };
    const [highlight, setHighlight] = (0,react.useState)("");
    const handleKeyDown = (e)=>{
        if (e.key === "Enter") {
            handlePartnerSigninSubmit(e);
            setHighlight("0.5px 0.5px 3px #fff, 2px 2px 10px #3165BA");
            setTimeout(()=>{
                setHighlight("");
            }, 1000);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
        show: show,
        dialogClassName: "model-custom",
        "aria-labelledby": "example-custom-modal-styling-title",
        fullscreen: "sm-down",
        className: "modal-signup modal-close mt-md-5",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                closeButton: true,
                onHide: resetPartnerSigninForm,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Title */.Z.Title, {
                    id: "example-custom-modal-styling-title",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                        className: "signup-header p-0 m-0 fw-bold",
                        children: "Partner Log In"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Body */.Z.Body, {
                className: "py-1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "pb-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default */.Z, {
                            onSubmit: handlePartnerSigninSubmit,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-12 mt-2 mb-lg-0 mb-3 mb-md-0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            className: "signup-text paragraph fw-semibold",
                                            children: "Email Address"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "email",
                                            placeholder: "Email Address",
                                            name: "partnerSigninEmail",
                                            value: partnerSigninEmail,
                                            onChange: handlePartnerSigninChange,
                                            className: "col-12 px-2 rounded border fw-500 py-2 signup-text ",
                                            required: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mt-2 mb-lg-0 mb-3 mb-md-0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            className: "signup-text paragraph fw-semibold pb-0 mb-0",
                                            children: "Password"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "border rounded col-12 d-flex flex-row ",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: showPassword ? "text" : "password",
                                                    placeholder: "Enter Password",
                                                    name: "partnerSigninPassword",
                                                    value: partnerSigninPassword,
                                                    onChange: handlePartnerSigninChange,
                                                    className: "col-11 px-2 rounded border-0 signup-text fw-500 py-2",
                                                    required: true,
                                                    onKeyDown: handleKeyDown
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-1 d-flex align-items-center justify-content-end pe-2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                        width: "10",
                                                        icon: showPassword ? free_regular_svg_icons/* faEye */.Mdf : free_regular_svg_icons/* faEyeSlash */.Aq,
                                                        // color="#5e5e5e87"
                                                        className: "pointer",
                                                        style: {
                                                            width: "19px",
                                                            opacity: "0.5"
                                                        },
                                                        onClick: ()=>setShowPassword(!showPassword)
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "d-flex flex-row align-items-center justify-content-between my-1 mb-lg-0 mb-3 mb-md-0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "d-flex flex-row align-items-center ",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    className: "form-check-input pointer mt-0",
                                                    type: "checkbox",
                                                    value: "",
                                                    id: "flexCheckDefault"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                    className: "form-check-label signup-text pointer fw-semibold ms-2 ",
                                                    htmlFor: "flexCheckDefault",
                                                    children: [
                                                        "Keep me log in",
                                                        " "
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "my-2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default.Link */.Z.Link, {
                                                href: "#",
                                                className: "p-0 m-0",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "m-0 signup-text text-dark-blue text-decoration-underline fw-semibold",
                                                    onClick: ()=>handleShowForgotPassword("partner"),
                                                    children: "Forgot Password?"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "btn btnHover btn-sm w-100 bg-dark-blue text-white fw-bold signup-text py-2",
                                    type: "submit",
                                    style: {
                                        width: "130px",
                                        boxShadow: highlight
                                    },
                                    onSubmit: handlePartnerSigninSubmit,
                                    children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                        animation: "border",
                                        size: "sm",
                                        variant: "light"
                                    }) : "Log in"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-12 d-flex align-items-center justify-content-center my-md-2 my-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "m-0 signup-text fw-500 d-flex flex-row align-items-center p-0 text-center",
                                children: [
                                    "Become a partner now?",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default.Link */.Z.Link, {
                                        href: "#",
                                        className: "p-0 m-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-dark-blue m-0 p-0 fw-bold ps-1",
                                            onClick: handleShowPartnerSignup,
                                            children: "Sign Up"
                                        })
                                    }),
                                    " "
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "border border-2 rounded bg-white p-2 w-100 paragraph d-flex align-items-center justify-content-start my-2",
                            onClick: handleShowSignin,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "m-0 w-100 fw-semibold text-center signup-text paragraph",
                                children: "Customer Log in"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Auth_PartnerSignIn = (PartnerSignIn);

// EXTERNAL MODULE: ./components/UI/CustomToast.tsx
var CustomToast = __webpack_require__(48509);
// EXTERNAL MODULE: ./redux/Login/redux/selector.tsx
var redux_selector = __webpack_require__(54549);
// EXTERNAL MODULE: ./redux/Login/redux/slice.tsx + 2 modules
var redux_slice = __webpack_require__(30387);
;// CONCATENATED MODULE: ./components/Auth/ForgotPassword.tsx


// redux






const ForgotPassword = (param)=>{
    let { handleShowSignin  } = param;
    const [isResetapiLoading, setisResetapiLoading] = (0,react.useState)(false);
    //
    const dispatch = (0,es/* useDispatch */.I0)();
    const ResetPasswordFormShow = (0,es/* useSelector */.v9)(redux_selector/* ResetPasswordForm */.tz);
    const form = (0,es/* useSelector */.v9)(redux_selector/* selectForgetPaswordFrom */.wX);
    const handleFieldChange = (evt)=>{
        const { name , value  } = evt.target;
        dispatch(redux_slice/* actions.updateForgetPasswordFormValue */.Nw.updateForgetPasswordFormValue({
            key: name,
            value
        }));
    };
    const handleClick = ()=>{
        if (form.email.length === 0) {
            (0,CustomToast/* default */.Z)("Please Enter Email", "ERROR");
            return;
        }
        if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(form.email)) {
            (0,CustomToast/* default */.Z)("Enter Valid Email ID", "ERROR");
            return;
        }
        dispatch(redux_slice/* actions.sendForgetPassword */.Nw.sendForgetPassword({
            callback: ()=>{
                dispatch(redux_slice/* actions.clearForgetPasswordFrom */.Nw.clearForgetPasswordFrom());
                dispatch(redux_slice/* actions.toggleSendResetPassword */.Nw.toggleSendResetPassword());
                dispatch(redux_slice/* actions.ResetPasswordFormShowHide */.Nw.ResetPasswordFormShowHide(false));
            }
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
            show: ResetPasswordFormShow,
            dialogClassName: "modal-90w ",
            "aria-labelledby": "example-custom-modal-styling-title",
            className: "modal-close",
            fullscreen: "sm-down",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                    closeButton: true,
                    onHide: ()=>dispatch(redux_slice/* actions.ResetPasswordFormShowHide */.Nw.ResetPasswordFormShowHide(false)),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Title */.Z.Title, {
                        id: "example-custom-modal-styling-title",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                            className: "signup-header p-0 m-0 fw-bold",
                            children: "Forgot Password"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Body */.Z.Body, {
                    className: "py-1",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "m-0 signup-text fw-semibold py-2",
                                children: "Enter the Email Address Associated with Your Account, and We'll Email You a Link to Reset Your Password"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "col-12 mt-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                className: "signup-text paragraph fw-semibold",
                                                children: "Email Address"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                type: "email",
                                                placeholder: "Email Address",
                                                className: "col-12 py-2 fw-500 px-2 rounded border signup-text",
                                                required: true,
                                                value: form === null || form === void 0 ? void 0 : form.email,
                                                name: "email",
                                                onChange: handleFieldChange
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "btn btnHover btn-sm w-100 bg-dark-blue text-white signup-text my-3 fw-bold py-2",
                                        type: "button",
                                        onClick: handleClick,
                                        children: isResetapiLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                            animation: "border",
                                            size: "sm",
                                            variant: "light"
                                        }) : "Send Reset Link "
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-12 d-flex align-items-center justify-content-center pb-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "m-0 signup-text d-flex flex-row align-items-center p-0 text-center fw-500",
                                    children: [
                                        "< Back to",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default.Link */.Z.Link, {
                                            href: "#",
                                            className: "p-0 m-0 signup-text",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-dark-blue m-0 p-0 fw-semibold ps-1 ",
                                                onClick: handleShowSignin,
                                                children: "Log In"
                                            })
                                        }),
                                        " "
                                    ]
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Auth_ForgotPassword = (ForgotPassword);

// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 40 modules
var axios = __webpack_require__(78945);
// EXTERNAL MODULE: ./environment.tsx
var environment = __webpack_require__(58034);
// EXTERNAL MODULE: ./node_modules/jwt-decode/build/jwt-decode.esm.js
var jwt_decode_esm = __webpack_require__(96245);
// EXTERNAL MODULE: ./utils/logger.ts
var logger = __webpack_require__(81923);
;// CONCATENATED MODULE: ./components/Auth/Verification.tsx










const USER = "".concat(environment/* BASE_URL */._n, "verifyMail/");
const PARTNER = "".concat(environment/* BASE_URL */._n, "auth/partner/verifyMail/");
const Verification = (param)=>{
    let { userType , show , handleShowVerification , handleShowPartnerSignin , handleShowSignin  } = param;
    const router = (0,next_router.useRouter)();
    const { verify  } = router.query;
    const [decode, setDecode] = (0,react.useState)("");
    const [isLoading, setisLoading] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        if (verify) {
            let decode = (0,jwt_decode_esm/* default */.Z)(verify);
            setDecode(decode);
            (0,logger/* log */.c)("decode", decode);
        }
    }, [
        verify
    ]);
    const closeModal = ()=>{
        router.push("/");
        handleShowVerification();
    };
    const handleSubmit = (e)=>{
        const URL = (decode === null || decode === void 0 ? void 0 : decode.user) == "Partner" ? PARTNER : USER;
        setisLoading(true);
        axios/* default.post */.Z.post("".concat(URL).concat(decode === null || decode === void 0 ? void 0 : decode.id), {
            status: "Active"
        }).then((response)=>{
            setisLoading(false);
            (0,CustomToast/* default */.Z)("Email Verified, Please login to continue", "SUCCESS");
            if ((decode === null || decode === void 0 ? void 0 : decode.user) === "Partner") {
                router.push("/");
                handleShowPartnerSignin();
            } else {
                router.push("/");
                handleShowSignin();
            }
        }).catch((error)=>{
            var _error_response, _error_response_data;
            setisLoading(false);
            // log(" error user", error?.response);
            (0,CustomToast/* default */.Z)((error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : (_error_response_data = _error_response.data) === null || _error_response_data === void 0 ? void 0 : _error_response_data.responseMsg) || "Something went wrong ", "ERROR");
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
            show: show,
            dialogClassName: "modal-90w ",
            "aria-labelledby": "example-custom-modal-styling-title",
            className: "partner-login modal-close mt-5",
            fullscreen: "sm-down",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                    closeButton: true,
                    style: {
                        borderBottom: "none"
                    },
                    onHide: closeModal
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default.Body */.Z.Body, {
                    className: "text-center pb-5",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                            className: "fs-14 py-2",
                            children: decode === null || decode === void 0 ? void 0 : decode.email
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: "btn btnHover btn-sm shadow-none bg-dark-blue text-white fs-12 py-2 mb-2",
                            style: {
                                width: "130px"
                            },
                            onClick: handleSubmit,
                            children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                animation: "border",
                                size: "sm",
                                variant: "light"
                            }) : "Verify Email"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Auth_Verification = (Verification);

// EXTERNAL MODULE: ./components/Auth/PasswordValidation.tsx
var PasswordValidation = __webpack_require__(54876);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Dropdown.js + 16 modules
var Dropdown = __webpack_require__(81288);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Navbar.js + 4 modules
var Navbar = __webpack_require__(59126);
// EXTERNAL MODULE: ./styles/Home.module.css
var Home_module = __webpack_require__(7160);
var Home_module_default = /*#__PURE__*/__webpack_require__.n(Home_module);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Alert.js
var Alert = __webpack_require__(88375);
;// CONCATENATED MODULE: ./container/auth/AuthAlert.tsx



const AuthAlert = (param)=>{
    let { handleShowAlert , alert  } = param;
    const displayerror = {
        server: "Something went wrong try again later.",
        custom: alert.message
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
            variant: "danger",
            onClose: ()=>handleShowAlert(false),
            dismissible: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: displayerror[alert.type]
            })
        })
    });
};
/* harmony default export */ var auth_AuthAlert = (AuthAlert);

// EXTERNAL MODULE: ./node_modules/react-cookie/es6/useCookies.js + 6 modules
var useCookies = __webpack_require__(70461);
// EXTERNAL MODULE: ./redux/Admin/User/redux/slice.tsx
var User_redux_slice = __webpack_require__(55014);
// EXTERNAL MODULE: ./redux/Frontend/WishList/redux/slice.tsx
var WishList_redux_slice = __webpack_require__(32123);
// EXTERNAL MODULE: ./redux/Admin/SettingSection/SiteSetting/redux/selector.tsx
var SiteSetting_redux_selector = __webpack_require__(63287);
// EXTERNAL MODULE: ./redux/School/SchoolPayments/redux/selector.tsx
var SchoolPayments_redux_selector = __webpack_require__(4657);
// EXTERNAL MODULE: ./redux/Admin/SettingSection/Languages/redux/selector.tsx
var Languages_redux_selector = __webpack_require__(90854);
// EXTERNAL MODULE: ./redux/School/SchoolPayments/redux/slice.tsx
var SchoolPayments_redux_slice = __webpack_require__(52600);
// EXTERNAL MODULE: ./redux/Admin/SettingSection/Languages/redux/slice.tsx
var Languages_redux_slice = __webpack_require__(57451);
// EXTERNAL MODULE: ./redux/Frontend/WishList/redux/selector.tsx
var WishList_redux_selector = __webpack_require__(34847);
// EXTERNAL MODULE: ./components/Firebase.utils.tsx
var Firebase_utils = __webpack_require__(76855);
;// CONCATENATED MODULE: ./components/Auth/ResetPassword.tsx



// redux




const ResetPassword = (param)=>{
    let { handleShowSignin , handleShowForgotPassword  } = param;
    const router = (0,next_router.useRouter)();
    const dispatch = (0,es/* useDispatch */.I0)();
    const show = (0,es/* useSelector */.v9)(redux_selector/* selectResetPasswordSendEmail */.fe);
    const form = (0,es/* useSelector */.v9)(redux_selector/* selectForgetPaswordFrom */.wX);
    const email = (0,es/* useSelector */.v9)(redux_selector/* selectResetEmailAddress */.FV);
    const handleClose = ()=>{
        dispatch(redux_slice/* actions.toggleSendResetPassword */.Nw.toggleSendResetPassword());
    };
    const handleResend = ()=>{
        dispatch(redux_slice/* actions.toggleSendResetPassword */.Nw.toggleSendResetPassword());
        dispatch(redux_slice/* actions.ResetPasswordFormShowHide */.Nw.ResetPasswordFormShowHide(true));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
            show: show,
            dialogClassName: "modal-90w ",
            "aria-labelledby": "example-custom-modal-styling-title",
            className: "modal-close",
            fullscreen: "sm-down",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                    closeButton: true,
                    onHide: handleClose,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Title */.Z.Title, {
                        id: "example-custom-modal-styling-title text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                            className: "signup-header p-0 m-0 fw-bold ",
                            children: "Password Reset"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Body */.Z.Body, {
                    className: "py-1",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                            className: " text-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-12 mt-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/images/ResetPassowrd.svg",
                                        alt: "",
                                        className: "img-fluid"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "m-0 signup-text fw-semibold py-2",
                                    children: [
                                        "Check",
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            style: {
                                                color: "#3165BA"
                                            },
                                            children: [
                                                " ",
                                                email,
                                                " "
                                            ]
                                        }),
                                        " To Confirm. It Will Consist of a Link to Help Reset Your Password."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "m-0 signup-text fw-semibold py-2",
                                    children: [
                                        "Didn't Receive an Email? Let Us",
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            onClick: handleResend,
                                            className: "pointer ",
                                            style: {
                                                color: "#3165BA"
                                            },
                                            children: [
                                                " ",
                                                "Resend",
                                                " "
                                            ]
                                        }),
                                        " ",
                                        "You."
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Auth_ResetPassword = (ResetPassword);

// EXTERNAL MODULE: ./components/CheckBox/index.tsx
var CheckBox = __webpack_require__(88023);
// EXTERNAL MODULE: ./components/Password/index.tsx + 1 modules
var Password = __webpack_require__(62330);
;// CONCATENATED MODULE: ./components/layout/main-layout/MainNavbar.tsx







































function MainNavBar(param) {
    let { getStartedPartner , login , navHeaderName , currencshow  } = param;
    var _userDetails_profilePic, _settingData_welcomeBar, _userDetails_profilePic1, _userDetails_profilePic2, _userDetails_name, _userDetails_profilePic3, _userDetails_profilePic4, _userDetails_name1;
    const [openProfileMenu, setopenProfileMenu] = (0,react.useState)(false);
    const [openMenu, setopenMenu] = (0,react.useState)(false);
    const [openCurrencyMenu, setopenCurrencyMenu] = (0,react.useState)(false);
    const [show, setShow] = react.useState(false);
    const [userType, setUserType] = react.useState("user");
    const [showAlert, setShowAlert] = react.useState(false);
    const [showAlertType, setShowAlertType] = react.useState({
        type: null,
        errorMessage: null
    });
    const [cookieToken, setCookieToken, removeCookieToken] = (0,useCookies/* default */.Z)([
        "token"
    ]);
    const [showPassword, setShowPassword] = (0,react.useState)(false);
    const [showSignIn, setShowSignIn] = react.useState(false);
    const [showPartnerSignIn, setShowPartnerSignIn] = react.useState(false);
    const [showResetPassword, setShowResetPassword] = react.useState(false);
    const [showBecomeAPartner, setShowBecomeAPartner] = react.useState(false);
    const [showVerification, setShowVetification] = react.useState(false);
    const [activeCurrency, setActiveCurrency] = (0,react.useState)();
    const [activeCurrencyText, setActiveCurrencyText] = (0,react.useState)();
    const [activeLang, setActiveLang] = (0,react.useState)("EN");
    const [activeLangText, setActiveLangText] = (0,react.useState)("English-EN");
    const [settingData, setSettingData] = (0,react.useState)();
    const [showBanner, setShowBanner] = (0,react.useState)(true);
    const logo = (0,es/* useSelector */.v9)(SiteSetting_redux_selector/* selectSiteSettingForm */.Ku);
    const emailRegex = /^[a-zA-Z0-9.]+@[a-z]+\.[a-z]{2,3}$/;
    const nameRegExp = /^([a-zA-Z]+\s?)*\s*$/;
    const closeBanner = ()=>{
        setShowBanner(false);
    };
    const router = (0,next_router.useRouter)();
    const { verify , becomeHost , signup  } = router.query;
    (0,react.useEffect)(()=>{
        if (becomeHost) {
            handleshowBecomeAPartner();
        }
    }, [
        becomeHost
    ]);
    (0,react.useEffect)(()=>{
        if (signup) {
            handleShowSignin();
        }
    }, [
        signup
    ]);
    (0,react.useEffect)(()=>{
        if (getStartedPartner == true) handleshowBecomeAPartner();
    }, [
        getStartedPartner
    ]);
    (0,react.useEffect)(()=>{
        if (login == true) handleShowSignin();
    }, [
        login
    ]);
    const handleshowSignup = ()=>{
        setShowSignIn(false);
        dispatch(redux_slice/* actions.ShowHideSignUp */.Nw.ShowHideSignUp(true));
        setShowVetification(false);
    };
    const handleshowBecomeAPartner = ()=>{
        dispatch(redux_slice/* actions.SignInFormShowHide */.Nw.SignInFormShowHide(false));
        dispatch(redux_slice/* actions.ShowHideSignUp */.Nw.ShowHideSignUp(false));
        dispatch(redux_slice/* actions.PartnerSignInFormShowHide */.Nw.PartnerSignInFormShowHide(true));
        dispatch(redux_slice/* actions.ResetPasswordFormShowHide */.Nw.ResetPasswordFormShowHide(false));
        dispatch(redux_slice/* actions.ShowVetificationFormShowHide */.Nw.ShowVetificationFormShowHide(false));
        dispatch(redux_slice/* actions.BecomeAPartnerFormShowHide */.Nw.BecomeAPartnerFormShowHide(true));
    };
    const handleshowPartnerSignin = ()=>{
        dispatch(redux_slice/* actions.ResetPasswordFormShowHide */.Nw.ResetPasswordFormShowHide(false));
        dispatch(redux_slice/* actions.SignInFormShowHide */.Nw.SignInFormShowHide(false));
        dispatch(redux_slice/* actions.ShowHideSignUp */.Nw.ShowHideSignUp(false));
        dispatch(redux_slice/* actions.PartnerSignInFormShowHide */.Nw.PartnerSignInFormShowHide(false));
        dispatch(redux_slice/* actions.ShowVetificationFormShowHide */.Nw.ShowVetificationFormShowHide(false));
        dispatch(redux_slice/* actions.BecomeAPartnerFormShowHide */.Nw.BecomeAPartnerFormShowHide(false));
    };
    const handleshowForgotPassword = (user)=>{
        dispatch(redux_slice/* actions.SignInFormShowHide */.Nw.SignInFormShowHide(false));
        dispatch(redux_slice/* actions.ShowHideSignUp */.Nw.ShowHideSignUp(false));
        dispatch(redux_slice/* actions.PartnerSignInFormShowHide */.Nw.PartnerSignInFormShowHide(false));
        dispatch(redux_slice/* actions.ResetPasswordFormShowHide */.Nw.ResetPasswordFormShowHide(true));
        dispatch(redux_slice/* actions.ShowVetificationFormShowHide */.Nw.ShowVetificationFormShowHide(false));
        dispatch(redux_slice/* actions.BecomeAPartnerFormShowHide */.Nw.BecomeAPartnerFormShowHide(false));
        user && setUserType(user);
    };
    const handleShowSignin = ()=>{
        dispatch(redux_slice/* actions.SignInFormShowHide */.Nw.SignInFormShowHide(true));
        dispatch(redux_slice/* actions.ShowHideSignUp */.Nw.ShowHideSignUp(false));
        dispatch(redux_slice/* actions.PartnerSignInFormShowHide */.Nw.PartnerSignInFormShowHide(false));
        dispatch(redux_slice/* actions.ResetPasswordFormShowHide */.Nw.ResetPasswordFormShowHide(false));
        dispatch(redux_slice/* actions.ShowVetificationFormShowHide */.Nw.ShowVetificationFormShowHide(false));
        dispatch(redux_slice/* actions.BecomeAPartnerFormShowHide */.Nw.BecomeAPartnerFormShowHide(false));
    };
    const handleShowVerification = ()=>{
        dispatch(redux_slice/* actions.SignInFormShowHide */.Nw.SignInFormShowHide(true));
        dispatch(redux_slice/* actions.ShowHideSignUp */.Nw.ShowHideSignUp(false));
        dispatch(redux_slice/* actions.PartnerSignInFormShowHide */.Nw.PartnerSignInFormShowHide(false));
        dispatch(redux_slice/* actions.ResetPasswordFormShowHide */.Nw.ResetPasswordFormShowHide(true));
        dispatch(redux_slice/* actions.ShowVetificationFormShowHide */.Nw.ShowVetificationFormShowHide(true));
        dispatch(redux_slice/* actions.BecomeAPartnerFormShowHide */.Nw.BecomeAPartnerFormShowHide(false));
    };
    const handleShowResetPassword = ()=>{
        dispatch(redux_slice/* actions.SignInFormShowHide */.Nw.SignInFormShowHide(true));
        dispatch(redux_slice/* actions.ShowHideSignUp */.Nw.ShowHideSignUp(false));
        dispatch(redux_slice/* actions.PartnerSignInFormShowHide */.Nw.PartnerSignInFormShowHide(false));
        dispatch(redux_slice/* actions.ResetPasswordFormShowHide */.Nw.ResetPasswordFormShowHide(true));
        dispatch(redux_slice/* actions.ShowVetificationFormShowHide */.Nw.ShowVetificationFormShowHide(true));
        dispatch(redux_slice/* actions.BecomeAPartnerFormShowHide */.Nw.BecomeAPartnerFormShowHide(false));
    };
    const handleShowAlert = (isShown)=>{
        setShowAlert(isShown);
        if (!isShown) {
            setShowAlertType({
                type: null,
                errorMessage: null
            });
        }
    };
    const NavItem = (param)=>/*#__PURE__*/ {
        let { navpage , icon , name , fa =false  } = param;
        return (0,jsx_runtime.jsx)((link_default()), {
            href: navpage,
            className: "col-12",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "navbar_list-item",
                children: [
                    fa ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: icon,
                        width: "15",
                        className: "navbar_list-icon"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: icon,
                        alt: "",
                        width: "15",
                        className: "navbar_list-icon"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: name
                    })
                ]
            })
        });
    };
    const NavItemDesktop = (param)=>/*#__PURE__*/ {
        let { icon , name , fa =false  } = param;
        return (0,jsx_runtime.jsxs)("span", {
            className: "navbardesktop_list-item",
            children: [
                fa ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                    icon: icon,
                    width: "14",
                    className: "navbardesktop_list-icon"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: icon,
                    alt: "",
                    width: "20",
                    className: "navbardesktop_list-icon"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: name
                })
            ]
        });
    };
    const ActiveLanguage = (0,es/* useSelector */.v9)(Languages_redux_selector/* selectALlActiveLanguageList */.Th);
    const ActiveCurrency = (0,es/* useSelector */.v9)(SchoolPayments_redux_selector/* selectAllActiveCurrencyListData */.IF);
    const wishList = (0,es/* useSelector */.v9)(WishList_redux_selector/* selectTotalWishlist */.bS);
    (0,react.useEffect)(()=>{
        dispatch(SchoolPayments_redux_slice/* actions.doGetCurrencyList */.Nw.doGetCurrencyList());
        dispatch(Languages_redux_slice/* actions.doGetAllActivelanguageList */.Nw.doGetAllActivelanguageList());
        return ()=>{};
    }, []);
    const [cookies, setCookie] = (0,useCookies/* default */.Z)([
        "currencyType"
    ]);
    const [language, setlanguage] = (0,useCookies/* default */.Z)([
        "languageType"
    ]);
    const [affiliatecode, setAffiliateCode] = (0,useCookies/* default */.Z)([
        "affiliateCode"
    ]);
    const userCurrency = (0,es/* useSelector */.v9)(redux_selector/* selectUserCurrencyCode */.UU);
    const selectcurrencyAdmin = (0,es/* useSelector */.v9)(SiteSetting_redux_selector/* selectSiteSettingForm */.Ku);
    const islogin = (0,es/* useSelector */.v9)(redux_selector/* selectIsLogin */.Q8);
    const affiliateCode = router.query.code;
    (0,react.useEffect)(()=>{
        if (affiliateCode == undefined && affiliateCode != affiliateCode && affiliateCode ? affiliateCode : affiliateCode) {
            setAffiliateCode("affiliateCode", affiliateCode, {
                path: "/",
                domain: environment/* COOKIE_DOMAIN */.JP,
                secure: true,
                sameSite: "none"
            });
        }
        return ()=>{};
    }, []);
    (0,react.useEffect)(()=>{
        if (userCurrency && islogin) {
            localStorage.setItem("currencyType", userCurrency);
            setCookie("currencyType", userCurrency, {
                path: "/",
                domain: environment/* COOKIE_DOMAIN */.JP,
                secure: true,
                sameSite: "none"
            });
        } else if (!cookies.currencyType) {
            if (selectcurrencyAdmin.currencyCode) {
                setCookie("currencyType", selectcurrencyAdmin.currencyCode, {
                    path: "/",
                    domain: environment/* COOKIE_DOMAIN */.JP,
                    secure: true,
                    sameSite: "none"
                });
            }
        }
        (0,logger/* log */.c)(userCurrency, "userCurrency");
        return ()=>{};
    }, [
        selectcurrencyAdmin.currencyCode,
        userCurrency,
        islogin
    ]);
    const CurrencySelector = (param)=>{
        let { text , value  } = param;
        const setCurrency = ()=>{
            setActiveCurrency(value);
            dispatch(redux_slice/* actions.setactiveCurrency */.Nw.setactiveCurrency(value));
            localStorage.setItem("currencyType", value);
            setCookie("currencyType", value, {
                path: "/",
                domain: environment/* COOKIE_DOMAIN */.JP,
                secure: true,
                sameSite: "none"
            });
            dispatch(User_redux_slice/* actions.updateUserFormValue */.Nw.updateUserFormValue({
                key: "currency",
                value: value
            }));
            setopenCurrencyMenu(!openCurrencyMenu);
            setActiveCurrencyText(text);
            dispatch(User_redux_slice/* actions.doupdateSchoolProfileDataCurrency */.Nw.doupdateSchoolProfileDataCurrency({
                currency: value,
                callback () {
                    router_default().reload();
                }
            }));
        };
        const activecurrency = getCookie("currencyType");
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            className: " ".concat(activecurrency === value ? "border-primary-active" : "border", "  btn btn-sm rounded-pill shadow-none px-2 px-md-3 fs-12  m-md-1 me-1 mb-2"),
            onClick: ()=>setCurrency(),
            children: text
        });
    };
    const getCookie = (cname)=>{
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(";");
        for(let i = 0; i < ca.length; i++){
            let c = ca[i];
            while(c.charAt(0) == " "){
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    };
    const LanguageSelector = (param)=>{
        let { text , value  } = param;
        const setLang = ()=>{
            setActiveLang(value);
            setopenCurrencyMenu(!openCurrencyMenu);
            localStorage.setItem("language", value);
            setlanguage("languageType", value, {
                path: "/",
                domain: environment/* COOKIE_DOMAIN */.JP,
                secure: true,
                sameSite: "none"
            });
            setActiveLangText(text);
            dispatch(redux_slice/* actions.setactiveLanguage */.Nw.setactiveLanguage(value));
            router_default().reload();
        };
        const activeLang = getCookie("languageType");
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            className: "".concat(activeLang === value ? "border-primary-active" : "border", " btn btn-sm rounded-pill shadow-none px-md-3 px-2 fs-12 m-md-1 me-1 mb-2"),
            onClick: setLang,
            children: text
        });
    };
    const CurrencyDropdown = ()=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default.Menu */.Z.Menu, {
                    className: "d-none d-md-block fs-normal fs-12 language-currency border shadow-sm mt-4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown/* default.Item */.Z.Item, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-12",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-dark fw-semibold fs-12 m-0 px-2",
                                        children: "Language"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                        className: "m-0 p-0 my-2"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: " px-2 flex-wrap",
                                        children: ActiveLanguage === null || ActiveLanguage === void 0 ? void 0 : ActiveLanguage.map((d, i)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LanguageSelector, {
                                                text: "".concat(d.name, "-").concat(d.code),
                                                value: d.code
                                            }, d.id);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-12 mt-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-dark fw-semibold fs-12 m-0 px-2",
                                        children: "Currency"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                        className: "m-0 p-0 my-2"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "d-flex ps-2 flex-wrap",
                                        children: ActiveCurrency === null || ActiveCurrency === void 0 ? void 0 : ActiveCurrency.map((d, i)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencySelector, {
                                                text: "".concat(d.name, "-").concat(d.code),
                                                value: d.code
                                            }, d.id);
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-12 d-lg-none pt-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col-12",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-dark fw-semibold fs-12 mb-1",
                                    children: "Language"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex-wrap",
                                    children: ActiveLanguage.map((d, i)=>{
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LanguageSelector, {
                                            text: "".concat(d.name, "-").concat(d.code),
                                            value: d.code
                                        }, d.id);
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                            className: "m-0 p-0 my-1"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col-12",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-dark fw-semibold fs-12 mb-1",
                                    children: "Currency"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "d-flex flex-wrap",
                                    children: ActiveCurrency.map((d, i)=>{
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencySelector, {
                                            text: "".concat(d.name, "-").concat(d.code),
                                            value: d.code
                                        }, d.id);
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    const dispatch = (0,es/* useDispatch */.I0)();
    const form = (0,es/* useSelector */.v9)(redux_selector/* selectUserForm */.pl);
    const handleSignupChange = (evt)=>{
        const { name , value  } = evt.target;
        dispatch(redux_slice/* actions.updateUserFormValue */.Nw.updateUserFormValue({
            key: name,
            value
        }));
        (0,logger/* log */.c)(form);
    };
    const [highlight, setHighlight] = (0,react.useState)("");
    const handleKeyDown = (e)=>{
        if (e.key === "Enter") {
            hendleUserSignUp();
            setHighlight("0.5px 0.5px 3px #fff, 2px 2px 10px #3165BA");
            setTimeout(()=>{
                setHighlight("");
            }, 1000);
        }
    };
    const hendleUserSignUp = ()=>{
        var _form_firstName, _form_lastName, _form_email, _form_password;
        dispatch(redux_slice/* actions.updateUserFormValue */.Nw.updateUserFormValue({
            key: "firstName",
            value: form === null || form === void 0 ? void 0 : (_form_firstName = form.firstName) === null || _form_firstName === void 0 ? void 0 : _form_firstName.trim()
        }));
        dispatch(redux_slice/* actions.updateUserFormValue */.Nw.updateUserFormValue({
            key: "lastName",
            value: form === null || form === void 0 ? void 0 : (_form_lastName = form.lastName) === null || _form_lastName === void 0 ? void 0 : _form_lastName.trim()
        }));
        dispatch(redux_slice/* actions.updateUserFormValue */.Nw.updateUserFormValue({
            key: "email",
            value: form === null || form === void 0 ? void 0 : (_form_email = form.email) === null || _form_email === void 0 ? void 0 : _form_email.trim()
        }));
        dispatch(redux_slice/* actions.updateUserFormValue */.Nw.updateUserFormValue({
            key: "password",
            value: form === null || form === void 0 ? void 0 : (_form_password = form.password) === null || _form_password === void 0 ? void 0 : _form_password.trim()
        }));
        if (!nameRegExp.test(form.firstName) || form.firstName.trim() == "") {
            (0,CustomToast/* default */.Z)("Enter Valid first Name", "ERROR");
            return;
        }
        if (!nameRegExp.test(form.lastName) || form.lastName.trim() == "") {
            (0,CustomToast/* default */.Z)("Enter Valid Last Name", "ERROR");
            return;
        }
        if (form.email.length === 0) {
            (0,CustomToast/* default */.Z)("Please Enter Email", "ERROR");
            return;
        }
        if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(form.email)) {
            (0,CustomToast/* default */.Z)("Enter Valid Email ID", "ERROR");
            return;
        }
        dispatch(redux_slice/* actions.doUserSignUp */.Nw.doUserSignUp({
            callback: ()=>{
                dispatch(redux_slice/* actions.ShowHideSignUp */.Nw.ShowHideSignUp(false));
                dispatch(redux_slice/* actions.clearUserFrom */.Nw.clearUserFrom());
            }
        }));
    };
    const userDetails = (0,es/* useSelector */.v9)(redux_selector/* selectUserData */.tT);
    const fetchMe = (tokenStr)=>{
        dispatch(redux_slice/* actions.getUserProfile */.Nw.getUserProfile({
            token: tokenStr,
            callback: (data)=>{
                if (userDetails.role == 3) {
                    if (data.role == 3 && data.id.length > 1) {
                        dispatch(User_redux_slice/* actions.doGetUserFormById */.Nw.doGetUserFormById({
                            id: data.id || ""
                        }));
                    } else {
                    // router.push("/");
                    }
                } else {}
            }
        }));
    };
    const handleLogout = ()=>{
        dispatch(redux_slice/* actions.doLogOut */.Nw.doLogOut());
        removeCookieToken("token", {
            path: "/",
            domain: environment/* COOKIE_DOMAIN */.JP,
            secure: true,
            sameSite: "none"
        });
        router.push("/");
    };
    const showHideSignUpForm = (0,es/* useSelector */.v9)(redux_selector/* selectSignUpForm */.wH);
    const handlesignupForm = (data)=>{
        dispatch(redux_slice/* actions.clearUserFrom */.Nw.clearUserFrom());
        dispatch(redux_slice/* actions.ShowHideSignUp */.Nw.ShowHideSignUp(data));
    };
    let token = "";
    // working
    (0,react.useEffect)(()=>{
        token = localStorage.getItem("token");
        fetchMe(token);
        if (token) {
            dispatch(WishList_redux_slice/* actions.doGetWishlist */.Nw.doGetWishlist());
        }
        return ()=>{};
    }, [
        token
    ]);
    const handleWishList = ()=>{
        token = localStorage.getItem("token");
        if (token && userDetails.role === 3) {
            router.push("/profile/wishlist");
        } else {
            handleShowSignin();
        }
    };
    const handleCheckBoxChange = (evt)=>{
        dispatch(redux_slice/* actions.updateUserFormValue */.Nw.updateUserFormValue({
            key: "acceptNewsLetter",
            value: evt.target.checked ? true : false
        }));
    };
    const splitWord = userDetails === null || userDetails === void 0 ? void 0 : (_userDetails_profilePic = userDetails.profilePic) === null || _userDetails_profilePic === void 0 ? void 0 : _userDetails_profilePic.split("");
    const splicevalue = splitWord === null || splitWord === void 0 ? void 0 : splitWord.splice(0, 6);
    const handleClickShowPassword = ()=>{
        setShowPassword(!showPassword);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            showBanner && /*#__PURE__*/ (0,jsx_runtime.jsx)(main_layout_MainBanner, {
                WelcomeBar: (settingData === null || settingData === void 0 ? void 0 : (_settingData_welcomeBar = settingData.welcomeBar) === null || _settingData_welcomeBar === void 0 ? void 0 : _settingData_welcomeBar.length) > 0 && (settingData === null || settingData === void 0 ? void 0 : settingData.welcomeBar[0]),
                closeBanner: closeBanner
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Navbar/* default */.Z, {
                expand: "lg",
                fixed: "top",
                id: "main-nav",
                className: "shadow-sm _nav_ ",
                style: {
                    position: "sticky"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "container ",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default.Brand */.Z.Brand, {
                                href: "/",
                                className: "",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-10 d-flex flex-row align-items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            className: " p-1 mt-1 img-fluid",
                                            src: "".concat((0,Api/* path */.E)()).concat(logo.logo),
                                            // height="auto"
                                            width: "70px",
                                            style: {
                                                objectFit: "cover"
                                            }
                                        }),
                                        navHeaderName ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                            className: "fw-bold ms-3",
                                            children: navHeaderName
                                        }) : // </h4>
                                        null
                                    ]
                                })
                            }),
                            navHeaderName ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "fw-bold headername-mobile-nav",
                                children: navHeaderName
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "d-flex align-items-center",
                                children: [
                                    !navHeaderName && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "wishlist-item d-lg-none me-3",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav/* default.Link */.Z.Link, {
                                            href: "",
                                            className: "",
                                            children: [
                                                userDetails.role === 3 && wishList > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "wishlis-notify-badge",
                                                    children: wishList
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/images/heart.svg",
                                                    alt: "globe",
                                                    className: "img-fluid",
                                                    id: "logo",
                                                    width: "26px",
                                                    onClick: handleWishList
                                                })
                                            ]
                                        })
                                    }),
                                    userDetails.role == 3 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav/* default.Link */.Z.Link, {
                                        "aria-controls": "profile-nav",
                                        className: "d-lg-none profileNav-toggle ms-auto ps-2 ms-1 d-flex align-items-center",
                                        onClick: ()=>{
                                            setopenMenu(!openMenu), setopenProfileMenu(false);
                                        },
                                        children: [
                                            userDetails.profilePic ? (splicevalue === null || splicevalue === void 0 ? void 0 : splicevalue.join(" ")) != "s c h o o l" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "".concat(((_userDetails_profilePic1 = userDetails.profilePic) === null || _userDetails_profilePic1 === void 0 ? void 0 : _userDetails_profilePic1.includes("googleusercontent.com")) ? "".concat(userDetails.profilePic) : userDetails.profilePic ? "".concat((0,Api/* path */.E)()).concat(userDetails.profilePic) : "".concat((0,Api/* path */.E)()).concat(userDetails.profilePic)),
                                                alt: "user",
                                                className: "img-fluid",
                                                id: "user",
                                                width: "28px",
                                                style: {
                                                    borderRadius: "50%",
                                                    backgroundColor: "white",
                                                    objectFit: "cover",
                                                    minWidth: "28px"
                                                }
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "".concat(((_userDetails_profilePic2 = userDetails.profilePic) === null || _userDetails_profilePic2 === void 0 ? void 0 : _userDetails_profilePic2.includes("googleusercontent.com")) ? "".concat(userDetails.profilePic) : userDetails.profilePic ? "".concat((0,Api/* path */.E)()).concat(userDetails.profilePic) : "".concat((0,Api/* path */.E)()).concat(userDetails.profilePic)),
                                                alt: "user",
                                                className: "img-fluid",
                                                id: "user",
                                                width: "28px",
                                                style: {
                                                    borderRadius: "50%",
                                                    backgroundColor: "white",
                                                    objectFit: "cover",
                                                    minWidth: "28px"
                                                }
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/images/user.svg",
                                                alt: "user",
                                                className: "img-fluid ",
                                                id: "user",
                                                width: "28px",
                                                style: {
                                                    borderRadius: "50%"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-dark fw-semibold fs-14 ms-1 ",
                                                children: userDetails === null || userDetails === void 0 ? void 0 : (_userDetails_name = userDetails.name) === null || _userDetails_name === void 0 ? void 0 : _userDetails_name.substring(0, 7)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default.Toggle */.Z.Toggle, {
                                        "aria-controls": "basic-navbar-nav ",
                                        onClick: ()=>{
                                            setopenMenu(false), setopenProfileMenu(!openProfileMenu);
                                        },
                                        className: "border-none pe-0"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "ps-3 ps-md-0 row w-100 d-none d-sm-none d-md-none align-items-md-none d-lg-flex align-items-lg-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-lg-6 ".concat((Home_module_default()).left_nav),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default */.Z, {
                                            className: "mr-auto d-flex align-items-center",
                                            children: navHeaderName ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default.Link */.Z.Link, {
                                                        href: "/about",
                                                        className: "ms-0 fs-15 fw-500",
                                                        children: "About"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default.Link */.Z.Link, {
                                                        href: "/blog/",
                                                        className: "fs-15 fw-500",
                                                        children: "Blog"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default.Link */.Z.Link, {
                                                        href: "/help",
                                                        className: "fs-15 fw-500",
                                                        children: "Help"
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-6 d-flex justify-content-end ".concat((Home_module_default()).right_nav, " pe-3"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav/* default */.Z, {
                                            className: "ml-auto d-flex align-items-center d-md-flex align-items-md-center justify-content-md-center flex-md-row d-sm-flex align-items-sm-center justify-content-sm-center flex-sm-row ",
                                            children: [
                                                !navHeaderName && /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default.Link */.Z.Link, {
                                                    href: "/become-partner",
                                                    className: "fs-15 fw-500 text-dark me-3",
                                                    children: "Become Partner"
                                                }),
                                                currencshow && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown/* default */.Z, {
                                                    style: {
                                                        background: "white"
                                                    },
                                                    show: openCurrencyMenu,
                                                    onToggle: ()=>setopenCurrencyMenu(!openCurrencyMenu),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default.Toggle */.Z.Toggle, {
                                                            id: "example-toggle",
                                                            className: "bg-white p-0 m-0 focus-off",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: "/images/globe.svg",
                                                                alt: "globe",
                                                                className: "img-fluid me-0",
                                                                id: "logo",
                                                                width: "22px"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyDropdown, {})
                                                    ]
                                                }),
                                                !navHeaderName && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "wishlist-item",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav/* default.Link */.Z.Link, {
                                                        href: "",
                                                        className: "me-2",
                                                        children: [
                                                            userDetails.role === 3 && wishList > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "wishlis-notify-badge",
                                                                children: wishList
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: "/images/heart.svg",
                                                                alt: "Wishlist",
                                                                className: "img-fluid me-0",
                                                                id: "wishlist",
                                                                width: "25px",
                                                                onClick: handleWishList
                                                            })
                                                        ]
                                                    })
                                                }),
                                                userDetails.role !== 3 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default.Link */.Z.Link, {
                                                    className: "btn btnHover btn-primary px-3 py-2 fs-12 shadow-none ",
                                                    onClick: ()=>handlesignupForm(true),
                                                    children: "Sign Up"
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown/* default */.Z, {
                                                        drop: "start",
                                                        className: "navbar__user-dropdown",
                                                        autoClose: "outside",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown/* default.Toggle */.Z.Toggle, {
                                                                id: "dropdown-basic",
                                                                className: "d-flex align-items-center ",
                                                                children: [
                                                                    userDetails.profilePic ? (splicevalue === null || splicevalue === void 0 ? void 0 : splicevalue.join(" ")) != "s c h o o l" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        src: "".concat(((_userDetails_profilePic3 = userDetails.profilePic) === null || _userDetails_profilePic3 === void 0 ? void 0 : _userDetails_profilePic3.includes("googleusercontent.com")) ? "".concat(userDetails.profilePic) : userDetails.profilePic ? "".concat((0,Api/* path */.E)()).concat(userDetails.profilePic) : "".concat((0,Api/* path */.E)()).concat(userDetails.profilePic)),
                                                                        alt: "user",
                                                                        className: "img-fluid",
                                                                        id: "user",
                                                                        width: "28px",
                                                                        style: {
                                                                            borderRadius: "50%",
                                                                            backgroundColor: "white",
                                                                            objectFit: "cover",
                                                                            minWidth: "28px"
                                                                        }
                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        src: "".concat(((_userDetails_profilePic4 = userDetails.profilePic) === null || _userDetails_profilePic4 === void 0 ? void 0 : _userDetails_profilePic4.includes("googleusercontent.com")) ? "".concat(userDetails.profilePic) : userDetails.profilePic ? "".concat((0,Api/* path */.E)()).concat(userDetails.profilePic) : "".concat((0,Api/* path */.E)()).concat(userDetails.profilePic)),
                                                                        alt: "user",
                                                                        className: "img-fluid",
                                                                        id: "user",
                                                                        width: "28px",
                                                                        style: {
                                                                            borderRadius: "50%",
                                                                            backgroundColor: "white",
                                                                            objectFit: "cover",
                                                                            minWidth: "28px"
                                                                        }
                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                        src: "/images/user.svg",
                                                                        alt: "user",
                                                                        className: "img-fluid",
                                                                        id: "user",
                                                                        width: "30px",
                                                                        style: {
                                                                            borderRadius: "50%"
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "text-dark fw-500 fs-14 ms-1",
                                                                        children: userDetails === null || userDetails === void 0 ? void 0 : (_userDetails_name1 = userDetails.name) === null || _userDetails_name1 === void 0 ? void 0 : _userDetails_name1.substring(0, 7)
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown/* default.Menu */.Z.Menu, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default.Item */.Z.Item, {
                                                                        href: "/profile/my-profile",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItemDesktop, {
                                                                            icon: "/images/people-header.svg",
                                                                            name: "My Profile"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown/* default.Item */.Z.Item, {
                                                                        href: "/messages",
                                                                        children: [
                                                                            " ",
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItemDesktop, {
                                                                                icon: "/images/chat.svg",
                                                                                name: "Messages"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default.Item */.Z.Item, {
                                                                        href: "/bookings",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItemDesktop, {
                                                                            icon: "/images/calendar-header.svg",
                                                                            name: "Bookings"
                                                                        })
                                                                    }),
                                                                    userDetails.isAffiliate && /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default.Item */.Z.Item, {
                                                                        href: "/affiliate/affiliatedashboard",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItemDesktop, {
                                                                            icon: "/images/affiliate.svg",
                                                                            name: "Affiliate Dashboard"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default.Item */.Z.Item, {
                                                                        href: "/profile/settings",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItemDesktop, {
                                                                            icon: "/images/gear-header.svg",
                                                                            name: "Settings"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default.Item */.Z.Item, {
                                                                        href: "/",
                                                                        onClick: handleLogout,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItemDesktop, {
                                                                            icon: "/images/exit-header.svg",
                                                                            name: "Logout"
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-12 d-flex d-sm-flex d-md-flex flex-column d-lg-none",
                                children: openMenu && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav/* default */.Z, {
                                    className: "col-12 d-flex align-items-start flex-column",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
                                            icon: "/images/people-header.svg",
                                            name: "My Profile",
                                            navpage: "/profile/my-profile"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
                                            icon: free_regular_svg_icons/* faHeart */.m6i,
                                            fa: true,
                                            name: "Wish list",
                                            navpage: "/profile/wishlist"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
                                            icon: "/images/chat.svg",
                                            name: "Messages",
                                            navpage: "/messages"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
                                            icon: "/images/calendar-header.svg",
                                            name: "Bookings",
                                            navpage: "/bookings"
                                        }),
                                        userDetails.isAffiliate && /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
                                            icon: "/images/affiliate.svg",
                                            name: "Affiliate Dashboard",
                                            navpage: "/affiliate/affiliatedashboard"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
                                            icon: "/images/gear-header.svg",
                                            name: "Settings",
                                            navpage: "/profile/settings"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/",
                                            onClick: ()=>handleLogout(),
                                            className: "col-12",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "navbar_list-item",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "/images/exit-header.svg",
                                                        alt: "",
                                                        width: "10",
                                                        className: "navbar_list-icon"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "Logout"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    openProfileMenu && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-12 col-md-11 container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav/* default */.Z, {
                                className: "d-flex align-items-start flex-column mt-3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default.Link */.Z.Link, {
                                        href: "/about",
                                        className: "navbar_list-item",
                                        children: "About"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default.Link */.Z.Link, {
                                        href: "/blog",
                                        className: "navbar_list-item",
                                        children: "Blog"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default.Link */.Z.Link, {
                                        href: "/help",
                                        className: "navbar_list-item",
                                        children: "Help"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default.Link */.Z.Link, {
                                        href: "/become-partner",
                                        className: "navbar_list-item",
                                        children: "Become Partner"
                                    })
                                ]
                            }),
                            currencshow && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-12 pt-2 ",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "d-flex align-items-center pb-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
                                            className: "fs-normal",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default.Toggle */.Z.Toggle, {
                                                id: "dropdown-basic",
                                                className: "text-decoration-none bg-white p-0 m-0 border-0 outline-none focus-off",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/images/globe.svg",
                                                    alt: "globe",
                                                    className: "img-fluid",
                                                    id: "logo",
                                                    width: "25px",
                                                    onClick: ()=>setopenCurrencyMenu(!openCurrencyMenu)
                                                })
                                            })
                                        })
                                    }),
                                    openCurrencyMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyDropdown, {})
                                ]
                            }),
                            userDetails.role !== 3 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-12 d-flex flex-row py-2 justify-content-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default.Link */.Z.Link, {
                                        href: "#",
                                        className: "col-6 btn btn-primary btnHover text-center px-3 py-2 fs-12 shadow-none",
                                        style: {
                                            maxWidth: "47%"
                                        },
                                        onClick: ()=>handlesignupForm(true),
                                        children: "Sign Up"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default.Link */.Z.Link, {
                                        href: "#",
                                        className: "col-6 btn-outline-primary btnHoverNew text-center rounded px-3 py-2 fs-12 shadow-none",
                                        onClick: handleShowSignin,
                                        style: {
                                            maxWidth: "47%"
                                        },
                                        children: "Sign In"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
                show: showHideSignUpForm,
                dialogClassName: "model-custom",
                "aria-labelledby": "example-custom-modal-styling-title",
                fullscreen: "sm-down",
                className: "modal-signup modal-close",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                        closeButton: true,
                        onHide: ()=>handlesignupForm(false),
                        className: "modal-close signup-header",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Title */.Z.Title, {
                            id: "example-custom-modal-styling-title",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                className: "signup-header p-0 m-0 fw-bold",
                                children: "Sign Up"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Body */.Z.Body, {
                        className: "py-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "",
                            children: [
                                showAlert && /*#__PURE__*/ (0,jsx_runtime.jsx)(auth_AuthAlert, {
                                    handleShowAlert: handleShowAlert,
                                    alert: showAlertType
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "col-12 d-flex justify-content-between flex-lg-row flex-md-row flex-column",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                            className: "signup-text paragraph fw-semibold",
                                                            children: "First Name"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "text",
                                                            placeholder: "First Name",
                                                            name: "firstName",
                                                            value: form.firstName,
                                                            onChange: handleSignupChange,
                                                            className: "py-2 px-2 rounded border w-100 signup-text mb-lg-0 mb-3 mb-md-0 fw-500",
                                                            required: true
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "ps-lg-3 ps-md-3 ps-sm-0",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                            className: "signup-text paragraph fw-semibold",
                                                            children: "Last Name"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "text",
                                                            placeholder: "Last Name",
                                                            name: "lastName",
                                                            value: form.lastName,
                                                            onChange: handleSignupChange,
                                                            className: "py-2 px-2 rounded border signup-text w-100 mb-lg-0 mb-2 mb-md-0 fw-500",
                                                            required: true
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "col-12 mt-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                    className: "signup-text paragraph fw-semibold",
                                                    children: "Email Address"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "text",
                                                    placeholder: "Enter Email Address",
                                                    name: "email",
                                                    value: form.email,
                                                    onChange: handleSignupChange,
                                                    className: "col-12 py-2 px-2 rounded border signup-text mb-lg-0 mb-2 mb-md-0 fw-500",
                                                    required: true
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "mt-2 ",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                    className: "signup-text paragraph fw-semibold",
                                                    children: "Password"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Password/* default */.Z, {
                                                    value: form.password,
                                                    name: "password",
                                                    className: "signup-text paragraph fw-500",
                                                    handleFieldChange: handleSignupChange,
                                                    placeholder: "Enter Password",
                                                    showPassword: showPassword,
                                                    handleClickShowPassword: handleClickShowPassword,
                                                    handleKeyDown: handleKeyDown
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordValidation/* default */.Z, {
                                                    password: form.password
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "d-flex flex-row align-items-center my-3",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBox/* default */.Z, {
                                                label: "I would like to receive the newsletter",
                                                name: "acceptNewsLetter",
                                                forChecked: form.acceptNewsLetter,
                                                handleFieldChange: (e)=>handleCheckBoxChange(e),
                                                className: "form-check-label signup-text pointer fw-semibold"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: "btn btnHover btn-sm w-100 bg-dark-blue text-white signup-text py-2 fw-semibold",
                                            type: "button",
                                            onClick: hendleUserSignUp,
                                            style: {
                                                boxShadow: highlight
                                            },
                                            children: "Sign Up"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "d-flex flex-row my-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                            className: "col-5"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "pe-1 col-2 fw-semibold ps-3 signup-text pt-2 font-weight-bold",
                                            children: "OR"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                            className: "col-5 "
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-12",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "border border-2 rounded bg-white pointer p-2 w-100 paragraph d-flex align-items-center justify-content-start my-2",
                                            onClick: ()=>{
                                                (0,Firebase_utils/* signInWithGoogle */.qj)().catch((error)=>{});
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/images/icons8-google.svg",
                                                    className: "img-fluid h-24",
                                                    style: {
                                                        height: "24px!important"
                                                    },
                                                    height: "24px",
                                                    width: "24px"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "m-0 w-100 fw-semibold text-center signup-text paragraph",
                                                    children: "Continue with Google"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-12 d-flex align-items-center justify-content-center my-md-2 my-3",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "m-0 signup-text fw-semibold d-flex flex-row align-items-center p-0 text-center",
                                                children: [
                                                    "Already have an account?",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default.Link */.Z.Link, {
                                                        href: "#",
                                                        className: "p-0 m-0 signup-text",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "text-dark-blue m-0 p-0 fw-semibold ps-1 ",
                                                            onClick: handleShowSignin,
                                                            children: "Log In"
                                                        })
                                                    }),
                                                    " "
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: "border byr-hover-black-theme-button border-2 rounded bg-white p-2 w-100 paragraph d-flex align-items-center justify-content-start my-2",
                                            onClick: handleshowBecomeAPartner,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "m-0 w-100 fw-semibold text-center signup-text paragraph",
                                                children: "Partner Sign Up"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Auth_ForgotPassword, {
                userType: userType,
                show: showResetPassword,
                handleShowForgotPassword: handleshowForgotPassword,
                handleShowSignin: handleShowSignin,
                handleShowResetPassword: handleShowResetPassword
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Auth_ResetPassword, {
                userType: userType,
                show: showResetPassword,
                handleShowResetPassword: handleShowResetPassword,
                handleShowSignin: handleShowSignin,
                handleShowForgotPassword: handleshowForgotPassword
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SignIn/* default */.Z, {
                show: showSignIn,
                handleShowSignin: handleShowSignin,
                handleShowSignup: handleshowSignup,
                handleShowForgotPassword: handleshowForgotPassword,
                handleShowPartnerSignup: handleshowBecomeAPartner
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Auth_Verification, {
                show: showVerification,
                handleShowVerification: handleShowVerification,
                handleShowPartnerSignin: handleshowPartnerSignin,
                handleShowSignin: handleShowSignin
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerSignup/* default */.Z, {
                show: showBecomeAPartner,
                handleShowSignup: handleshowBecomeAPartner,
                handleShowSignin: handleShowSignin
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Auth_PartnerSignIn, {
                show: showPartnerSignIn,
                handleShowPartnerSignup: handleshowBecomeAPartner,
                handleShowPartnerSignin: handleshowPartnerSignin,
                handleShowForgotPassword: handleshowForgotPassword,
                handleShowSignin: handleShowSignin
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/layout/main-layout/MainFooter.tsx






function MainFooter() {
    const logo = (0,es/* useSelector */.v9)(SiteSetting_redux_selector/* selectSiteSettingForm */.Ku);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
            id: "footersection",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col-lg-3 footer-second-link-col",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/images/footerLogo.png",
                                    alt: "Yoga Retreat",
                                    className: "img-fluid logo footer-log-mobile",
                                    style: {
                                        height: "55px",
                                        width: "auto"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "footer-text fw-400",
                                    style: {
                                        textAlign: "justify"
                                    },
                                    children: "We understand the power of retreats. That’s why we have come together to help you connect with life-altering yoga retreats, wellness programs, and comprehensive yoga teacher training. We love seeing you happy and rejuvenated!"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: "d-flex ps-0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                icon: [
                                                    "far",
                                                    "envelope"
                                                ],
                                                width: "15",
                                                className: "byr-footer-mail-icon"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "ms-2 email",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "mailto:".concat(logo.customerSupportEmail),
                                                children: logo.customerSupportEmail
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                    className: "footer-text fw-500",
                                    style: {
                                        color: "#222222"
                                    },
                                    children: "Follow us on Social Media"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: "d-flex ps-0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "https://www.instagram.com/bookyourretreats/",
                                                target: "_blank",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/images/footer/ig.svg",
                                                    alt: "instagram",
                                                    className: "img-fluid footer-social-icon"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "ms-2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "https://www.youtube.com/channel/UCxAeJ7aoc9iZAqcyjOsj2WA",
                                                target: "_blank",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/images/footer/yt.svg",
                                                    alt: "youtube",
                                                    className: "img-fluid footer-social-icon"
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col-lg-3 ps-lg-5 ps-lg-0 footer-first-link-col",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: "first_section ps-0 ps-lg-4 ps-xl-5 footer-first-link-col-list",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "title",
                                            children: "Support"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "title_paragraph",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/help",
                                                children: "Contact Us"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "title_paragraph",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/cancellation-policies",
                                                children: "Cancellation Policies"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "title_paragraph",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/privacy-policy",
                                                children: "Privacy Policy"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "title_paragraph",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/terms-and-conditions",
                                                children: "Terms and Conditions"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: "second_section ps-0 ps-lg-4 ps-xl-5 footer-first-link-col-list",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "title",
                                            children: "Popular Yoga Retreats"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "title_paragraph",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/l/india/yoga-retreat/best-yoga-retreat-in-india",
                                                children: "Best Yoga Retreat In India"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "title_paragraph",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/l/bali/yoga-retreat/best-yoga-retreat-in-bali",
                                                children: "Best Yoga Retreat In Bali"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "title_paragraph",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/l/srilanka/yoga-retreat/best-yoga-retreat-in-srilanka",
                                                children: "Best Yoga Retreat In SriLanka"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "title_paragraph",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/l/nepal/yoga-retreat/best-yoga-retreat-in-nepal",
                                                children: "Best Yoga Retreat In Nepal"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "title_paragraph",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/l/rishikesh/yoga-retreat/best-yoga-retreat-in-rishikesh",
                                                children: "Best Yoga Retreat In Rishikesh"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "title_paragraph",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/l/goa/yoga-retreat/best-yoga-retreat-in-goa",
                                                children: "Best Yoga Retreat In Goa"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col-lg-3 ps-lg-0 footer-second-link-col",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: "first_section ps-0 ps-lg-3 ps-xl-5 footer-second-link-col-list",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "title",
                                            children: "For Guests"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "title_paragraph",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/about",
                                                children: "About Us"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "title_paragraph",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/help",
                                                children: "Contact Us"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "title_paragraph",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/sitemap",
                                                children: "Sitemap"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "title_paragraph",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/affiliate",
                                                children: "Affiliates"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "title_paragraph",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/blog",
                                                children: "Blog"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: "second_section ps-0 ps-lg-3 ps-xl-5 footer-second-link-col-list",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "title footer-special-width",
                                            children: "Popular Yoga Teacher Training"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "title_paragraph",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/l/india/yoga-teacher-training/best-yoga-teacher-training-in-india",
                                                children: "Best Yoga Teacher Training In India"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "title_paragraph",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/l/bali/yoga-teacher-training/best-yoga-teacher-training-in-bali",
                                                children: "Best Yoga Teacher Training In Bali"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "title_paragraph",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/l/srilanka/yoga-teacher-training/best-yoga-teacher-training-in-srilanka",
                                                children: "Best Yoga Teacher Training In SriLanka"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "title_paragraph",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/l/nepal/yoga-teacher-training/best-yoga-teacher-training-in-nepal",
                                                children: "Best Yoga Teacher Training In Nepal"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "title_paragraph",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/l/rishikesh/yoga-teacher-training/best-yoga-teacher-training-in-rishikesh",
                                                children: "Best Yoga Teacher Training In Rishikesh"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "title_paragraph",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/l/goa/yoga-teacher-training/best-yoga-teacher-training-in-goa",
                                                children: "Best Yoga Teacher Training In Goa"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-lg-3 ps-lg-0 footer-second-link-col",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: "first_section ps-0 ps-lg-4 ps-xl-5",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "title",
                                        children: "For Host"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "title_paragraph",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/help",
                                            children: "Help"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "title_paragraph",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/become-partner",
                                            children: "Become Partner"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "title_paragraph",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/online-yoga-teacher-training",
                                            children: "Add Online Training"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "title_paragraph",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/affiliate",
                                            children: "Affiliates"
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-lg-12 bottom-footer d-flex justify-content-center justify-content-md-start",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "fw-400",
                                style: {
                                    color: "#222222",
                                    opacity: "0.65"
                                },
                                children: "\xa9 2024 Book Your Retreats. All Rights Reserved."
                            })
                        })
                    ]
                })
            })
        })
    });
}

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./redux/Admin/SettingSection/SiteSetting/redux/slice.tsx
var SiteSetting_redux_slice = __webpack_require__(62779);
// EXTERNAL MODULE: ./components/socket.ts
var socket = __webpack_require__(25871);
// EXTERNAL MODULE: ./redux/User/Message/redux/slice.tsx
var Message_redux_slice = __webpack_require__(39693);
// EXTERNAL MODULE: ./redux/School/Massage/redux/slice.tsx
var Massage_redux_slice = __webpack_require__(17178);
;// CONCATENATED MODULE: ./components/layout/main-layout/MainLayout.tsx

















function MainLayout(param) {
    let { hasFooter =true , children , getStartedPartner , login , navHeaderName , currencshow  } = param;
    const userDetails = (0,es/* useSelector */.v9)(redux_selector/* selectUserData */.tT);
    const form = (0,es/* useSelector */.v9)(SiteSetting_redux_selector/* selectSiteSettingForm */.Ku);
    const dispatch = (0,es/* useDispatch */.I0)();
    const router = (0,next_router.useRouter)();
    const InquiryId = router.query.id;
    let schoolid = "";
    (0,react.useEffect)(()=>{
        schoolid = localStorage.getItem("SchoolId");
        return ()=>{};
    }, []);
    (0,react.useEffect)(()=>{
        dispatch(SiteSetting_redux_slice/* actions.doGetSiteSettingList */.Nw.doGetSiteSettingList());
    }, []);
    const getCookie = (cname)=>{
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(";");
        for(let i = 0; i < ca.length; i++){
            let c = ca[i];
            while(c.charAt(0) == " "){
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    };
    function onConnect() {
        (0,logger/* log */.c)("====================================");
        (0,logger/* log */.c)("socket: onConnect");
        (0,logger/* log */.c)("====================================");
    }
    function onDisconnect() {
        (0,logger/* log */.c)("====================================");
        (0,logger/* log */.c)("socket: onDisconnect");
        (0,logger/* log */.c)("====================================");
    }
    function onFooEvent(value) {
        (0,logger/* log */.c)("====================================");
        (0,logger/* log */.c)("socket: onFooEvent", value);
        (0,logger/* log */.c)("====================================");
    }
    (0,react.useEffect)(()=>{
        if (socket/* socket.connected */.W.connected && userDetails.id.length > 0) {
            socket/* socket.emit */.W.emit("JOIN", userDetails.id);
        }
        return ()=>{};
    }, [
        socket/* socket.connected */.W.connected,
        userDetails.id
    ]);
    (0,react.useEffect)(()=>{
        socket/* socket.on */.W.on("connect", onConnect);
        socket/* socket.on */.W.on("disconnect", onDisconnect);
        socket/* socket.on */.W.on("ACKNOWLEDGEMENT", onFooEvent);
        socket/* socket.on */.W.on("connect_error", (err)=>{
            (0,logger/* log */.c)("socket: connect_error due to ".concat(err.message));
        });
        socket/* socket.on */.W.on("MESSAGE_RECEIVED", (value)=>{
            dispatch(Message_redux_slice/* actions.doGetMessageList */.Nw.doGetMessageList({
                id: value.userId ? value.userId : value.inquiryId,
                schoolId: schoolid,
                pageNo: 1
            }));
            dispatch(Massage_redux_slice/* actions.dogetPackageDetail */.Nw.dogetPackageDetail(value.userId ? value.userId : value.inquiryId));
        });
        return ()=>{
            socket/* socket.off */.W.off("connect", onConnect);
            socket/* socket.off */.W.off("disconnect", onDisconnect);
            socket/* socket.off */.W.off("ACKNOWLEDGEMENT", onFooEvent);
            socket/* socket.off */.W.off("connect_error", onFooEvent);
        };
    }, []);
    const [currency, setCurrency] = (0,react.useState)("USD");
    const [language, setlanguage] = (0,react.useState)("eng");
    (0,react.useEffect)(()=>{
        setCurrency(getCookie("currencyType"));
        setlanguage(getCookie("languageType"));
    }, []);
    const [cookies, setCookie] = (0,useCookies/* default */.Z)([
        "currencyType"
    ]);
    const [languageType, setlanguageType] = (0,useCookies/* default */.Z)([
        "languageType"
    ]);
    (0,react.useEffect)(()=>{
        if (currency.length == 0) {}
        if (language.length == 0) {
            localStorage.setItem("languageType", "eng");
            setlanguageType("languageType", "eng", {
                path: "/",
                domain: environment/* COOKIE_DOMAIN */.JP,
                secure: true,
                sameSite: "none"
            });
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "icon",
                    href: "".concat((0,Api/* path */.E)()).concat(form.favicon)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainNavBar, {
                getStartedPartner: getStartedPartner,
                login: login,
                navHeaderName: navHeaderName,
                currencshow: currencshow
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: " p-1 mt-1",
                    src: "".concat((0,Api/* path */.E)()).concat(form.favicon),
                    height: "auto",
                    width: "50px"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    position: "relative"
                },
                children: children
            }),
            hasFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)(MainFooter, {})
        ]
    });
}


/***/ }),

/***/ 25871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ socket; }
/* harmony export */ });
/* harmony import */ var socket_io_client__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53920);
/* harmony import */ var _config_json__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51181);


const socket = (0,socket_io_client__WEBPACK_IMPORTED_MODULE_0__.io)(_config_json__WEBPACK_IMPORTED_MODULE_1__/* .SOCKET_URL */ .o5, {
    reconnectionDelay: 1000,
    reconnection: true,
    transports: [
        "websocket",
        "polling"
    ],
    agent: false,
    upgrade: false,
    rejectUnauthorized: false
});


/***/ }),

/***/ 7160:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"Home_main__nLjiQ","mainlanding":"Home_mainlanding__rVVD8","headerContainer":"Home_headerContainer__dbWZE","header_title":"Home_header_title__1bhed","header_paragraph":"Home_header_paragraph__xZiQL","title":"Home_title__T09hD","description":"Home_description__41Owk","footer":"Home_footer____T7K","code":"Home_code__suPER","grid":"Home_grid__GxQ85","card":"Home_card___LpL1","logo":"Home_logo__27_tb","right_nav":"Home_right_nav__fYvxR","left_nav":"Home_left_nav__LojKo","featuredReview":"Home_featuredReview__8XPFF","featured":"Home_featured__vfm0u","btn_container":"Home_btn_container__aBnpu","productCard":"Home_productCard__JWuVC","category_name":"Home_category_name__KZmtY","productTitle":"Home_productTitle__kTjCT","rating":"Home_rating__OdU0K","currency":"Home_currency__ymweR","productImage":"Home_productImage__xSq9q","image_container":"Home_image_container__OLGGl","badge":"Home_badge__DqLCN","coupon_badge":"Home_coupon_badge__U8yKa","btn_curved":"Home_btn_curved__iEyPi","grey_featured":"Home_grey_featured___u_Gr","grey_featured_product":"Home_grey_featured_product__Z27Lk","variants":"Home_variants__YEves","cta_section":"Home_cta_section__o5Paj","testimonial_static":"Home_testimonial_static__CrR28","reviewBox":"Home_reviewBox__mQFjK","reviewTitle":"Home_reviewTitle__Se7yU","reviewDesc":"Home_reviewDesc__BREv_","reviews":"Home_reviews__RJ_mB","more_details":"Home_more_details__UQp0r","btn_review":"Home_btn_review__IdIxe","subscribe_block":"Home_subscribe_block__LhSbT","discoverRetreats":"Home_discoverRetreats__Q_E3E","StillSearchingBg":"Home_StillSearchingBg__B2P3i","StillSearching":"Home_StillSearching__GypKS","ReviewBlock":"Home_ReviewBlock__Os_2o","subscribe":"Home_subscribe__tc_vH","caret-off":"Home_caret-off__OKjdm","dropdown-toggle":"Home_dropdown-toggle__ao0JY","bg_photoVideos":"Home_bg_photoVideos__tLGCD"};

/***/ })

}]);